<template>
  <div style="display: contents;">
              <v-btn
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="teal darken-3"
                  class="ma-1 flex-grow-1 flex-sm-grow-0 white--text"
                  elevation="0"
                  @click="abrirDialogCampanhaVendaMargem"
                  v-if="permissao('dashboard_ranking_campanha_venda_margem_diretoria')"
              >
                Campanha de Vendas 2ª Edição
                <v-progress-circular
                    v-if="carregandoVendaMargem"
                    indeterminate
                    color="white"
                    :size="$vuetify.breakpoint.xsOnly ? 14 : 16"
                    width="2"
                    class="ml-1 ml-sm-2"
                />
                <v-icon v-else :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-cash-multiple
                </v-icon>
              </v-btn>

      <!-- DIALOG CAMPANHA VENDA E MARGEM (DIRETORIA) -->
      <v-dialog v-model="dialogCampanhaVendaMargem" max-width="1500" :fullscreen="$vuetify.breakpoint.width<450" scrollable>
        <v-card>
          <v-card-title class="white--text" style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%);">
            <div class="d-flex align-center" style="width: 100%;">
              <v-icon color="white" class="mr-2" size="28">mdi-cash-multiple</v-icon>
              <div>
                <div class="text-h6 font-weight-bold">Campanha de Vendas 2ª Edição</div>
                <div class="text-caption d-none d-sm-block">2º Semestre 2026 · 01/07/2026 a 31/12/2026</div>
              </div>
              <v-spacer />
              <v-img class="d-none d-md-flex" max-width="220" src="../../assets/icons/logo_min.png" />
            </div>
          </v-card-title>

          <v-tabs
              v-model="abaCampanhaVendaMargem"
              background-color="transparent"
              show-arrows
              height="48px"
              slider-color="primary"
              slider-size="3"
              color="primary"
              class="elevation-1"
          >
            <v-tab
                v-for="mes in campanhaVendaMargemMeses"
                :key="mes.mes"
                :tab-value="mes.mes"
                class="font-weight-medium text-capitalize"
            >
              <v-icon left size="20" class="mr-2">mdi-calendar-month</v-icon>
              <span>{{ mes.mes_formatado }}</span>
            </v-tab>
            <v-tab key="acumulado" tab-value="acumulado" class="font-weight-medium text-capitalize">
              <v-icon left size="20" class="mr-2">mdi-chart-box-outline</v-icon>
              <span>Acumulado Geral</span>
            </v-tab>
            <v-tab
                v-if="permissao('dashboard_ranking_campanha_venda_margem_sorteio')"
                key="resultado-sorteio"
                tab-value="resultado-sorteio"
                class="font-weight-medium text-capitalize"
            >
              <v-icon left size="20" class="mr-2">mdi-trophy-award</v-icon>
              <span>Resultado Sorteio</span>
            </v-tab>
          </v-tabs>

          <v-divider />

          <v-card-text class="black--text pt-2 mb-n3">
            <div v-if="carregandoVendaMargem" class="text-center py-12">
              <v-progress-circular :size="80" :width="8" color="primary" indeterminate>
                <v-icon color="primary" size="40">mdi-cash-multiple</v-icon>
              </v-progress-circular>
              <div class="mt-6 text-h6 font-weight-bold black--text">Carregando classificação da campanha...</div>
            </div>
            <v-tabs-items v-else v-model="abaCampanhaVendaMargem">

              <!-- UMA ABA POR MÊS JÁ DECORRIDO -->
              <v-tab-item v-for="mes in campanhaVendaMargemMeses" :key="mes.mes" :value="mes.mes">

                <!-- CARDS TOTALIZADORES POR REGRA/BLOCO (conferência rápida contra a apuração manual) -->
                <v-expansion-panels v-model="painelTotalizadoresCampanha" flat class="campanha-totais-expansion mb-2">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                        class="px-4 py-1"
                        style="min-height: 44px; background: #F7F9FA; border-left: 4px solid #0B5C73;"
                    >
                      <div class="d-flex align-center">
                        <v-icon size="18" color="#0B5C73" class="mr-2">mdi-ticket-percent-outline</v-icon>
                        <span class="text-subtitle-2 font-weight-bold" style="color: #0B5C73;">Totalizadores de cupons por regra</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0">
                      <!-- em telas md+ os 7 cards ficam numa linha só (v-col sem cols/sm fixo = largura flexível); em telas menores, empilha em grade -->
                      <v-row dense class="mt-1">
                        <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="primary"
                        title="Regra 1"
                        subtitle="Classificação mensal"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="Classificação mensal (OURO, PRATA, BRONZE ou NÃO ATINGIU) com base no % de atingimento da meta. Os cupons variam por faixa de margem dentro de cada classificação: quanto maior a margem, mais cupons."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'regra1')"
                    >
                      <template>{{ (mes.totais || {}).cupons_regra1 || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="primary"
                        title="Bloco A"
                        subtitle="Quem mais vendeu na rede"

                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="15 cupons: quem mais vendeu no mês entre todas as filiais da rede, desde que feche a meta (≥100%) e supere 23% de margem (21% Televendas). Sem fallback: se o maior vendedor não bater os critérios, ninguém ganha o bloco no mês."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'a')"
                    >
                      <template>{{ (mes.totais || {}).cupons_bloco_a || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="primary"
                        title="Bloco B"
                        subtitle="Quem mais vendeu na filial"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="10 cupons: quem mais vendeu no mês em cada filial, desde que feche a meta (≥100%) e supere 23% de margem (21% Televendas). Mesma regra do Bloco A, mas apurada filial por filial. Sem fallback: se o maior vendedor da filial não bater os critérios, ninguém ganha o bloco naquela filial no mês."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'b')"
                    >
                      <template>{{ (mes.totais || {}).cupons_bloco_b || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="primary"
                        title="Bloco C"
                        subtitle="Top 10 e-book"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="10 cupons: estar entre os 10 vendedores da rede com mais pontos na campanha Educa Comercial Ivaiporã (e-book) no mês. O ranking é por pontuação, não por valor de venda."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'c')"
                    >
                      <template>{{ (mes.totais || {}).cupons_bloco_c || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="primary"
                        title="Bloco D"
                        subtitle="Produto sem giro"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="10 cupons: estar entre os 10 vendedores da rede que mais venderam produtos 'sem giro' (R$) no mês, somando o valor de todos os produtos elegíveis vendidos por cada vendedor."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'd')"
                    >
                      <template>{{ (mes.totais || {}).cupons_bloco_d || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="primary"
                        title="Bloco E"
                        subtitle="Individual (margem + meta)"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="5 cupons: regra individual, sem disputa com outros vendedores. Vale pra qualquer vendedor que superar 23% de margem (21% Televendas) e atingir pelo menos 85% da meta no mês."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'e')"
                    >
                      <template>{{ (mes.totais || {}).cupons_bloco_e || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md v-if="mesFechaTrimestre(mes.mes)">
                    <CardDashboard
                        color="primary"
                        title="Bloco F"
                        subtitle="Meta do trimestre"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="20 cupons: superar a meta do trimestre (soma dos 3 meses) e superar 23% de margem (21% Televendas). Sem limite de vendedores — vale pra todo mundo que bater os dois critérios. Só aparece em setembro (fecha jul-ago-set) e dezembro (fecha out-nov-dez)."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'f')"
                    >
                      <template>{{ (mes.totais || {}).cupons_bloco_f || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                  <v-col cols="6" sm="4" md>
                    <CardDashboard
                        color="green darken-2"
                        title="Total Geral"
                        subtitle="Regra 1 + Extras"
                        icon="mdi-eye-outline"
                        class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                        style-content="color: #FFF !important; font-size: 1.15rem;"
                        class-title="pa-1 text-center text-truncate"
                        style-title="font-size: 0.7rem; line-height: 1.1;"
                        info-tooltip="Soma de todos os cupons do vendedor no mês: Regra 1 (classificação) + Blocos A, B, C, D, E e F (extras)."
                        @click:icon="abrirDetalheBlocoCampanha(mes, 'total')"
                    >
                      <template>{{ (mes.totais || {}).total_cupons || 0 }}</template>
                    </CardDashboard>
                  </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- SELETOR DE VISÃO DA TABELA -->
                <div class="d-flex justify-end align-center mb-2" style="gap: 12px;">
                  <div class="campanha-acao-imagem-group d-flex align-center">
                    <v-tooltip v-if="!suportaCopiarImagem()" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn small depressed disabled class="campanha-acao-imagem-btn"><v-icon small>mdi-content-copy</v-icon></v-btn>
                        </span>
                      </template>
                      <span>Seu navegador não suporta copiar imagem — use "Baixar"</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            small depressed class="campanha-acao-imagem-btn"
                            v-bind="attrs" v-on="on"
                            :loading="imagemProcessando === `${refImagemMes(mes)}:copiar`"
                            :disabled="!!imagemProcessando"
                            @click="copiarImagemTabela(refImagemMes(mes))"
                        >
                          <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copiar tabela como imagem</span>
                    </v-tooltip>
                    <div class="campanha-acao-imagem-divisor" />
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            small depressed class="campanha-acao-imagem-btn"
                            v-bind="attrs" v-on="on"
                            :loading="imagemProcessando === `${refImagemMes(mes)}:baixar`"
                            :disabled="!!imagemProcessando"
                            @click="baixarImagemTabela(refImagemMes(mes), `campanha-venda-margem-${mes.mes}-${visaoTabelaCampanha}.png`)"
                        >
                          <v-icon small>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Baixar tabela como imagem</span>
                    </v-tooltip>
                  </div>
                  <v-btn-toggle v-model="visaoTabelaCampanha" dense mandatory rounded color="primary" class="visao-toggle">
                    <v-btn small value="classificacao">
                      <v-icon small left>mdi-medal-outline</v-icon>
                      <span class="d-none d-sm-inline">Classificação</span>
                    </v-btn>
                    <v-btn small value="filial">
                      <v-icon small left>mdi-store-outline</v-icon>
                      <span class="d-none d-sm-inline">Filial</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <!-- VISÃO 1: AGRUPADO POR CLASSIFICAÇÃO -->
                <div v-if="visaoTabelaCampanha === 'classificacao'" style="position: relative;">
                <v-overlay :value="processandoImagem(refImagemMes(mes))" absolute opacity="0.7">
                  <div class="d-flex flex-column align-center">
                    <v-progress-circular indeterminate size="40" width="4" color="white" />
                    <div class="mt-3 text-body-2">Gerando imagem...</div>
                  </div>
                </v-overlay>
                <div :ref="`tabelaMesClassificacao_${mes.mes}`">
                <v-simple-table dense style="border: 1px solid #023449">
                  <thead>
                  <tr class="primary" style="height: 50px;">
                    <th class="white--text text-subtitle-2">Classificação</th>
                    <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Meta</th>
                    <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Venda</th>
                    <th class="white--text text-center text-subtitle-2">
                      % Atingimento
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              icon x-small class="ml-1"
                              v-bind="attrs" v-on="on"
                              @click="mostrarValoresFinanceiros = !mostrarValoresFinanceiros"
                          >
                            <v-icon x-small color="white">{{ mostrarValoresFinanceiros ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ mostrarValoresFinanceiros ? 'Ocultar' : 'Exibir' }} venda/meta/margem</span>
                      </v-tooltip>
                    </th>
                    <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Margem</th>
                    <th class="white--text text-center text-subtitle-2">Cupons Regra 1</th>
                    <th class="white--text text-center text-subtitle-2">Cupons Extras</th>
                    <th class="white--text text-center text-subtitle-2">Total Cupons</th>
                  </tr>
                  </thead>
                  <template v-if="mesAgrupado(mes.lista).length">
                  <tbody v-for="grupo in mesAgrupado(mes.lista)" :key="chaveGrupo(mes.mes, grupo.classificacao)">
                  <tr
                      style="cursor: pointer;"
                      class="grey lighten-3 font-weight-bold"
                      @click="toggleGrupo(chaveGrupo(mes.mes, grupo.classificacao))"
                  >
                    <td class="py-2 text-no-wrap" style="min-height: 40px;">
                      <div class="d-flex align-center flex-nowrap">
                        <v-icon size="18" class="mr-1">
                          {{ gruposExpandidos.has(chaveGrupo(mes.mes, grupo.classificacao)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                        </v-icon>
                        <v-chip small :color="classificacaoCor(grupo.classificacao)" dark class="font-weight-bold mr-2">
                          {{ grupo.classificacao }}
                        </v-chip>
                        <span class="text-no-wrap">{{ grupo.itens.length }} vendedor(es)</span>
                      </div>
                    </td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.meta) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.venda) }}</td>
                    <td class="text-center">{{ formatarPercentual(grupo.totais.peratingimento) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(grupo.totais.margem) }}</td>
                    <td class="text-center">{{ grupo.totais.cuponsRegra1 }}</td>
                    <td class="text-center">{{ grupo.totais.cuponsExtras }}</td>
                    <td class="text-center"><strong>{{ grupo.totais.totalCupons }}</strong></td>
                  </tr>
                  <tr v-show="gruposExpandidos.has(chaveGrupo(mes.mes, grupo.classificacao))" class="grey lighten-4" style="height: 32px;">
                    <th class="text-truncate">Vendedor / Filial</th>
                    <th v-if="mostrarValoresFinanceiros" class="text-center">Meta</th>
                    <th v-if="mostrarValoresFinanceiros" class="text-center">Venda</th>
                    <th class="text-center">% Atingimento</th>
                    <th v-if="mostrarValoresFinanceiros" class="text-center">Margem</th>
                    <th class="text-center">Cupons Regra 1</th>
                    <th class="text-center">Cupons Extras</th>
                    <th class="text-center">Total Cupons</th>
                  </tr>
                  <tr
                      v-for="item in grupo.itens"
                      v-show="gruposExpandidos.has(chaveGrupo(mes.mes, grupo.classificacao))"
                      :key="`${item.idempresa}-${item.idvendedor}`"
                      class="font-weight-bold"
                  >
                    <td style="height: 36px !important; width:220px; max-width: 260px !important;" class="text-truncate">
                      <div class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</div>
                      <div class="d-flex align-center" style="gap: 4px;">
                        <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark>Demitido</v-chip>
                        <div class="text-caption grey--text text--darken-1 text-truncate" :title="item.empresa" style="min-width: 0;">{{ item.empresa }}</div>
                      </div>
                    </td>
                    <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.meta) }}</td>
                    <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.venda) }}</td>
                    <td style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.peratingimento) }}</td>
                    <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.margem) }}</td>
                    <td style="height: 36px !important;" class="text-center">{{ item.cupons_regra1 }}</td>
                    <td style="height: 36px !important;" class="text-center">
                      <v-tooltip v-if="cuponsExtras(item) > 0" color="blue-grey" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{ cuponsExtras(item) }}</span>
                        </template>
                        <div class="white--text py-1">
                          <div v-for="(bloco, idx) in cuponsExtrasBlocos(item)" :key="idx">{{ bloco }}</div>
                        </div>
                      </v-tooltip>
                      <span v-else>0</span>
                    </td>
                    <td style="height: 36px !important;" class="text-center">
                      <strong>{{ item.total_cupons }}</strong>
                    </td>
                  </tr>
                  </tbody>
                  </template>
                  <tbody v-else>
                  <tr>
                    <td :colspan="mostrarValoresFinanceiros ? 8 : 5" class="text-center py-4">Nenhum vendedor classificado neste mês.</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="mesAgrupado(mes.lista).length">
                  <tr class="primary white--text font-weight-bold" style="height: 40px;">
                    <td class="text-uppercase">Total ({{ mes.lista.length }} vendedores)</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargem(mes.lista).meta) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargem(mes.lista).venda) }}</td>
                    <td class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargem(mes.lista).peratingimento) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargem(mes.lista).margem) }}</td>
                    <td class="text-center">{{ totaisCampanhaVendaMargem(mes.lista).cuponsRegra1 }}</td>
                    <td class="text-center">{{ totaisCampanhaVendaMargem(mes.lista).cuponsExtras }}</td>
                    <td class="text-center">{{ totaisCampanhaVendaMargem(mes.lista).totalCupons }}</td>
                  </tr>
                  </tfoot>
                </v-simple-table>
                </div>
                </div>

                <!-- VISÃO 2: AGRUPADO POR FILIAL -->
                <div v-if="visaoTabelaCampanha === 'filial'" style="position: relative;">
                <v-overlay :value="processandoImagem(refImagemMes(mes))" absolute opacity="0.7">
                  <div class="d-flex flex-column align-center">
                    <v-progress-circular indeterminate size="40" width="4" color="white" />
                    <div class="mt-3 text-body-2">Gerando imagem...</div>
                  </div>
                </v-overlay>
                <div :ref="`tabelaMesFilial_${mes.mes}`">
                <v-simple-table dense style="border: 1px solid #023449">
                  <thead>
                  <tr class="primary" style="height: 50px;">
                    <th class="white--text text-subtitle-2">Filial</th>
                    <th class="white--text text-center text-subtitle-2">Classificações</th>
                    <th class="white--text text-center text-subtitle-2 text-no-wrap">
                      % Participação
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon x-small color="white" class="ml-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>% de vendedores da loja classificados (diferente de NÃO ATINGIU) sobre o total de vendedores da loja</span>
                      </v-tooltip>
                    </th>
                    <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Meta</th>
                    <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Venda</th>
                    <th class="white--text text-center text-subtitle-2">
                      % Atingimento
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              icon x-small class="ml-1"
                              v-bind="attrs" v-on="on"
                              @click="mostrarValoresFinanceiros = !mostrarValoresFinanceiros"
                          >
                            <v-icon x-small color="white">{{ mostrarValoresFinanceiros ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ mostrarValoresFinanceiros ? 'Ocultar' : 'Exibir' }} venda/meta/margem</span>
                      </v-tooltip>
                    </th>
                    <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Margem</th>
                    <th class="white--text text-center text-subtitle-2">Cupons Regra 1</th>
                    <th class="white--text text-center text-subtitle-2">Cupons Extras</th>
                    <th class="white--text text-center text-subtitle-2">Total Cupons</th>
                  </tr>
                  </thead>
                  <template v-if="mesAgrupadoPorFilial(mes.lista).length">
                  <tbody v-for="grupo in mesAgrupadoPorFilial(mes.lista)" :key="chaveGrupoFilial(grupo.idempresa)">
                  <tr
                      style="cursor: pointer;"
                      class="grey lighten-3 font-weight-bold"
                      @click="toggleGrupo(chaveGrupoFilial(grupo.idempresa))"
                  >
                    <td class="py-2 text-no-wrap" style="min-height: 40px;">
                      <div class="d-flex align-center flex-nowrap">
                        <v-icon size="18" class="mr-1">
                          {{ gruposExpandidos.has(chaveGrupoFilial(grupo.idempresa)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                        </v-icon>
                        <span class="text-no-wrap mr-2">{{ grupo.empresa }}</span>
                        <span class="text-no-wrap text-caption grey--text text--darken-1">{{ grupo.itens.length }} vendedor(es)</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex flex-nowrap justify-center" style="gap: 2px;">
                        <v-chip
                            v-for="resumo in classificacaoResumo(grupo.itens)"
                            :key="resumo.classificacao"
                            x-small
                            :color="resumo.qtd > 0 ? classificacaoCor(resumo.classificacao) : 'grey lighten-1'"
                            dark
                            class="font-weight-bold classificacao-medalha"
                        >
                          {{ resumo.qtd }}
                        </v-chip>
                      </div>
                    </td>
                    <td class="text-center">{{ formatarPercentual(participacaoCampanha(grupo.itens)) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.meta) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.venda) }}</td>
                    <td class="text-center">{{ formatarPercentual(grupo.totais.peratingimento) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(grupo.totais.margem) }}</td>
                    <td class="text-center">{{ grupo.totais.cuponsRegra1 }}</td>
                    <td class="text-center">{{ grupo.totais.cuponsExtras }}</td>
                    <td class="text-center"><strong>{{ grupo.totais.totalCupons }}</strong></td>
                  </tr>
                  <tr v-show="gruposExpandidos.has(chaveGrupoFilial(grupo.idempresa))" class="grey lighten-4" style="height: 32px;">
                    <th class="text-truncate">Vendedor</th>
                    <th class="text-center">Classificação</th>
                    <th class="text-center"></th>
                    <th v-if="mostrarValoresFinanceiros" class="text-center">Meta</th>
                    <th v-if="mostrarValoresFinanceiros" class="text-center">Venda</th>
                    <th class="text-center">% Atingimento</th>
                    <th v-if="mostrarValoresFinanceiros" class="text-center">Margem</th>
                    <th class="text-center">Cupons Regra 1</th>
                    <th class="text-center">Cupons Extras</th>
                    <th class="text-center">Total Cupons</th>
                  </tr>
                  <tr
                      v-for="item in grupo.itens"
                      v-show="gruposExpandidos.has(chaveGrupoFilial(grupo.idempresa))"
                      :key="`filial-${item.idempresa}-${item.idvendedor}`"
                      class="font-weight-bold"
                  >
                    <td style="width:220px; max-width: 260px !important;" class="text-truncate py-1">
                      <div class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</div>
                      <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark class="mt-1">Demitido</v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip x-small :color="classificacaoCor(item.classificacao)" dark class="font-weight-bold">
                        {{ item.classificacao }}
                      </v-chip>
                    </td>
                    <td style="height: 36px !important;" class="text-center"></td>
                    <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.meta) }}</td>
                    <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.venda) }}</td>
                    <td style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.peratingimento) }}</td>
                    <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.margem) }}</td>
                    <td style="height: 36px !important;" class="text-center">{{ item.cupons_regra1 }}</td>
                    <td style="height: 36px !important;" class="text-center">
                      <v-tooltip v-if="cuponsExtras(item) > 0" color="blue-grey" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{ cuponsExtras(item) }}</span>
                        </template>
                        <div class="white--text py-1">
                          <div v-for="(bloco, idx) in cuponsExtrasBlocos(item)" :key="idx">{{ bloco }}</div>
                        </div>
                      </v-tooltip>
                      <span v-else>0</span>
                    </td>
                    <td style="height: 36px !important;" class="text-center">
                      <strong>{{ item.total_cupons }}</strong>
                    </td>
                  </tr>
                  </tbody>
                  </template>
                  <tbody v-else>
                  <tr>
                    <td :colspan="mostrarValoresFinanceiros ? 10 : 7" class="text-center py-4">Nenhum vendedor classificado neste mês.</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="mesAgrupadoPorFilial(mes.lista).length">
                  <tr class="primary white--text font-weight-bold" style="height: 40px;">
                    <td class="text-uppercase">Total ({{ mes.lista.length }} vendedores)</td>
                    <td class="text-center">
                      <div class="d-flex flex-nowrap justify-center" style="gap: 2px;">
                        <v-chip
                            v-for="resumo in classificacaoResumo(mes.lista)"
                            :key="resumo.classificacao"
                            x-small
                            :color="resumo.qtd > 0 ? classificacaoCor(resumo.classificacao) : 'grey lighten-1'"
                            dark
                            class="font-weight-bold classificacao-medalha"
                        >
                          {{ resumo.qtd }}
                        </v-chip>
                      </div>
                    </td>
                    <td class="text-center">{{ formatarPercentual(participacaoCampanha(mes.lista)) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargem(mes.lista).meta) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargem(mes.lista).venda) }}</td>
                    <td class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargem(mes.lista).peratingimento) }}</td>
                    <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargem(mes.lista).margem) }}</td>
                    <td class="text-center">{{ totaisCampanhaVendaMargem(mes.lista).cuponsRegra1 }}</td>
                    <td class="text-center">{{ totaisCampanhaVendaMargem(mes.lista).cuponsExtras }}</td>
                    <td class="text-center">{{ totaisCampanhaVendaMargem(mes.lista).totalCupons }}</td>
                  </tr>
                  </tfoot>
                </v-simple-table>
                </div>
                </div>
              </v-tab-item>

              <!-- ABA ACUMULADO -->
              <v-tab-item key="acumulado" value="acumulado">
                <!-- TOTALIZADORES + PERÍODO (meses inteiros) — o período só afeta esta aba; o Resultado Sorteio segue com o acumulado completo -->
                <div
                    class="periodo-filtro totalizadores-header d-flex flex-wrap align-center mt-1 mb-2 px-3 py-1"
                    @click="totalizadoresAcumuladoAberto = !totalizadoresAcumuladoAberto"
                >
                  <div class="d-flex align-center totalizadores-titulo">
                    <v-icon size="18" color="#0B5C73" class="mr-2">mdi-ticket-percent-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-bold" style="color: #0B5C73;">Totalizadores de cupons acumulados por regra</span>
                  </div>
                  <v-spacer />
                  <!-- .stop: mexer no período não deve expandir/recolher os totalizadores -->
                  <div class="d-flex align-center my-1 periodo-filtro-grupo" @click.stop>
                    <v-icon size="18" color="#0B5C73" class="mr-2">mdi-calendar-range</v-icon>
                    <span class="text-subtitle-2 font-weight-bold mr-3" style="color: #0B5C73;">Período</span>
                  <div class="periodo-filtro-campo">
                    <SeletorPeriodoMes
                        :inicio="filtroAcumuladoInicio"
                        :fim="filtroAcumuladoFim"
                        min-mes="2026-07"
                        :max-mes="periodoCampanhaTodaAcumulado.fim"
                        :atalhos="atalhosPeriodoAcumulado"
                        :disabled="carregandoAcumuladoFiltrado"
                        @aplicar="aplicarPeriodoAcumulado($event.inicio, $event.fim)"
                    />
                  </div>
                    <v-progress-circular v-if="carregandoAcumuladoFiltrado" indeterminate size="18" width="2" color="primary" class="ml-3" />
                  </div>
                  <v-btn icon small class="ml-2" aria-label="Expandir ou recolher totalizadores">
                    <v-icon>{{ totalizadoresAcumuladoAberto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <div
                      v-show="totalizadoresAcumuladoAberto"
                      class="mb-2 totalizadores-cards"
                      :class="{ 'totalizadores-cards--carregando': carregandoAcumuladoFiltrado }"
                  >
                        <v-row dense class="mt-1">
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Regra 1"
                                subtitle="Classificação acumulada"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons de classificação (OURO, PRATA, BRONZE) de todos os meses já decorridos, de todos os vendedores."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsRegra1 }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Bloco A"
                                subtitle="Quem mais vendeu na rede"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons do Bloco A de todos os meses já decorridos (15 cupons por mês pro maior vendedor da rede que fechar meta e margem)."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsBlocoA }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Bloco B"
                                subtitle="Quem mais vendeu na filial"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons do Bloco B de todos os meses já decorridos (10 cupons por mês pro maior vendedor de cada filial que fechar meta e margem)."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsBlocoB }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Bloco C"
                                subtitle="Top 10 e-book"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons do Bloco C de todos os meses já decorridos (10 cupons por mês pra quem ficar no top 10 de pontos da campanha e-book)."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsBlocoC }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Bloco D"
                                subtitle="Produto sem giro"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons do Bloco D de todos os meses já decorridos (10 cupons por mês pra quem ficar no top 10 de venda de produtos sem giro)."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsBlocoD }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Bloco E"
                                subtitle="Individual (margem + meta)"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons do Bloco E de todos os meses já decorridos (5 cupons por mês pra quem superar margem e atingir pelo menos 85% da meta)."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsBlocoE }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="primary"
                                title="Bloco F"
                                subtitle="Meta do trimestre"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma dos cupons do Bloco F de todos os trimestres já fechados (setembro e/ou dezembro)."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.cuponsBlocoF }}</template>
                            </CardDashboard>
                          </v-col>
                          <v-col cols="6" sm="4" md>
                            <CardDashboard
                                color="green darken-2"
                                title="Total Geral"
                                subtitle="Regra 1 + Extras"
                                class-content="py-1 px-1 text-center font-weight-bold text--white text-truncate"
                                style-content="color: #FFF !important; font-size: 1.15rem;"
                                class-title="pa-1 text-center text-truncate"
                                style-title="font-size: 0.7rem; line-height: 1.1;"
                                info-tooltip="Soma de todos os cupons (Regra 1 + Blocos) de todos os vendedores, em todos os meses já decorridos."
                            >
                              <template>{{ totaisCampanhaVendaMargemAcumulado.totalCupons }}</template>
                            </CardDashboard>
                          </v-col>
                        </v-row>
                  </div>
                </v-expand-transition>
                <div v-if="carregandoAcumuladoFiltrado" class="text-center py-12">
                  <v-progress-circular :size="80" :width="8" color="primary" indeterminate>
                    <v-icon color="primary" size="40">mdi-trophy-award</v-icon>
                  </v-progress-circular>
                  <div class="mt-6 text-h6 font-weight-bold black--text">Carregando acumulado da campanha...</div>
                </div>
                <div v-else>
                  <!-- SELETOR DE VISÃO DA TABELA -->
                  <div class="d-flex justify-end align-center mb-2" style="gap: 12px;">
                    <div class="campanha-acao-imagem-group d-flex align-center">
                      <v-tooltip v-if="!suportaCopiarImagem()" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <v-btn small depressed disabled class="campanha-acao-imagem-btn"><v-icon small>mdi-content-copy</v-icon></v-btn>
                          </span>
                        </template>
                        <span>Seu navegador não suporta copiar imagem — use "Baixar"</span>
                      </v-tooltip>
                      <v-tooltip v-else bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              small depressed class="campanha-acao-imagem-btn"
                              v-bind="attrs" v-on="on"
                              :loading="imagemProcessando === `${refImagemAcumulado()}:copiar`"
                              :disabled="!!imagemProcessando"
                              @click="copiarImagemTabela(refImagemAcumulado())"
                          >
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copiar tabela como imagem</span>
                      </v-tooltip>
                      <div class="campanha-acao-imagem-divisor" />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              small depressed class="campanha-acao-imagem-btn"
                              v-bind="attrs" v-on="on"
                              :loading="imagemProcessando === `${refImagemAcumulado()}:baixar`"
                              :disabled="!!imagemProcessando"
                              @click="baixarImagemTabela(refImagemAcumulado(), `campanha-venda-margem-acumulado-${visaoTabelaCampanha}.png`)"
                          >
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </template>
                        <span>Baixar tabela como imagem</span>
                      </v-tooltip>
                    </div>
                    <v-btn-toggle v-model="visaoTabelaCampanha" dense mandatory rounded color="primary" class="visao-toggle">
                      <v-btn small value="classificacao">
                        <v-icon small left>mdi-medal-outline</v-icon>
                        <span class="d-none d-sm-inline">Classificação</span>
                      </v-btn>
                      <v-btn small value="filial">
                        <v-icon small left>mdi-store-outline</v-icon>
                        <span class="d-none d-sm-inline">Filial</span>
                      </v-btn>
                    </v-btn-toggle>
                  </div>


                  <!-- VISÃO 1: AGRUPADO POR CLASSIFICAÇÃO -->
                  <div v-if="visaoTabelaCampanha === 'classificacao'" style="position: relative;">
                  <v-overlay :value="processandoImagem(refImagemAcumulado())" absolute opacity="0.7">
                    <div class="d-flex flex-column align-center">
                      <v-progress-circular indeterminate size="40" width="4" color="white" />
                      <div class="mt-3 text-body-2">Gerando imagem...</div>
                    </div>
                  </v-overlay>
                  <div ref="tabelaAcumuladoClassificacao">
                  <v-simple-table dense style="border: 1px solid #023449">
                    <thead>
                    <tr class="primary" style="height: 50px;">
                      <th class="white--text text-subtitle-2">Classificação</th>
                      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Meta Acumulada</th>
                      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Venda Acumulada</th>
                      <th class="white--text text-center text-subtitle-2">
                        % Atingimento Acumulado
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon x-small class="ml-1"
                                v-bind="attrs" v-on="on"
                                @click="mostrarValoresFinanceiros = !mostrarValoresFinanceiros"
                            >
                              <v-icon x-small color="white">{{ mostrarValoresFinanceiros ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ mostrarValoresFinanceiros ? 'Ocultar' : 'Exibir' }} venda/meta/margem</span>
                        </v-tooltip>
                      </th>
                      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Margem Acumulada</th>
                      <th class="white--text text-center text-subtitle-2">Cupons Regra 1</th>
                      <th class="white--text text-center text-subtitle-2">Cupons Extras</th>
                      <th class="white--text text-center text-subtitle-2">Total Cupons</th>
                    </tr>
                    </thead>
                    <template v-if="acumuladoAgrupado.length">
                    <tbody v-for="grupo in acumuladoAgrupado" :key="chaveGrupoAcumulado(grupo.classificacao)">
                    <tr
                        style="cursor: pointer;"
                        class="grey lighten-3 font-weight-bold"
                        @click="toggleGrupo(chaveGrupoAcumulado(grupo.classificacao))"
                    >
                      <td class="py-2 text-no-wrap" style="min-height: 40px;">
                        <div class="d-flex align-center flex-nowrap">
                          <v-icon size="18" class="mr-1">
                            {{ gruposExpandidos.has(chaveGrupoAcumulado(grupo.classificacao)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                          </v-icon>
                          <v-chip small :color="classificacaoCor(grupo.classificacao)" dark class="font-weight-bold mr-2">
                            {{ grupo.classificacao }}
                          </v-chip>
                          <span class="text-no-wrap">{{ grupo.itens.length }} vendedor(es)</span>
                        </div>
                      </td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.meta) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.venda) }}</td>
                      <td class="text-center">{{ formatarPercentual(grupo.totais.peratingimento) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(grupo.totais.margem) }}</td>
                      <td class="text-center">{{ grupo.totais.cuponsRegra1 }}</td>
                      <td class="text-center">{{ grupo.totais.cuponsExtras }}</td>
                      <td class="text-center"><strong>{{ grupo.totais.totalCupons }}</strong></td>
                    </tr>
                    <tr v-show="gruposExpandidos.has(chaveGrupoAcumulado(grupo.classificacao))" class="grey lighten-4" style="height: 32px;">
                      <th class="text-truncate">Vendedor / Filial</th>
                      <th v-if="mostrarValoresFinanceiros" class="text-center">Meta Acumulada</th>
                      <th v-if="mostrarValoresFinanceiros" class="text-center">Venda Acumulada</th>
                      <th class="text-center">% Atingimento Acumulado</th>
                      <th v-if="mostrarValoresFinanceiros" class="text-center">Margem Acumulada</th>
                      <th class="text-center">Cupons Regra 1</th>
                      <th class="text-center">Cupons Extras</th>
                      <th class="text-center">Total Cupons</th>
                    </tr>
                    <tr
                        v-for="item in grupo.itens"
                        v-show="gruposExpandidos.has(chaveGrupoAcumulado(grupo.classificacao))"
                        :key="`${item.idempresa}-${item.idvendedor}`"
                        class="font-weight-bold"
                    >
                      <td style="height: 36px !important; width:220px; max-width: 260px !important;" class="text-truncate">
                        <div class="d-flex align-center text-truncate">
                          <v-tooltip v-if="item.admitido_tardiamente === 'T'" color="blue-grey" bottom max-width="280">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="18" color="amber darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
                            </template>
                            <span class="white--text">
                              Admitido após 01/10/2026: não concorre ao sorteio do prêmio OURO. Só concorre aos demais
                              sorteios (PRATA/BRONZE) se superar R$ 130.000,00 (ou a meta do mês, se for maior) em
                              todos os meses participados.
                            </span>
                          </v-tooltip>
                          <span class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</span>
                        </div>
                        <div class="d-flex align-center" style="gap: 4px;">
                          <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark>Demitido</v-chip>
                          <div class="text-caption grey--text text--darken-1 text-truncate" :title="item.empresa" style="min-width: 0;">{{ item.empresa }}</div>
                        </div>
                      </td>
                      <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.meta_acumulada) }}</td>
                      <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.venda_acumulada) }}</td>
                      <td style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.peratingimento_acumulado) }}</td>
                      <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.margem_acumulada) }}</td>
                      <td style="height: 36px !important;" class="text-center">{{ item.cupons_regra1 }}</td>
                      <td style="height: 36px !important;" class="text-center">
                        <v-tooltip v-if="cuponsExtras(item) > 0" color="blue-grey" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ cuponsExtras(item) }}</span>
                          </template>
                          <div class="white--text py-1">
                            <div v-for="(bloco, idx) in cuponsExtrasBlocos(item)" :key="idx">{{ bloco }}</div>
                          </div>
                        </v-tooltip>
                        <span v-else>0</span>
                      </td>
                      <td style="height: 36px !important;" class="text-center"><strong>{{ item.total_cupons_acumulado }}</strong></td>
                    </tr>
                    </tbody>
                    </template>
                    <tbody v-else>
                    <tr>
                      <td :colspan="mostrarValoresFinanceiros ? 8 : 5" class="text-center py-4">Nenhum vendedor participante ainda.</td>
                    </tr>
                    </tbody>
                    <tfoot v-if="acumuladoAgrupado.length">
                    <tr class="primary white--text font-weight-bold" style="height: 40px;">
                      <td class="text-uppercase">Total ({{ campanhaVendaMargemAcumuladoFiltrado.length }} vendedores)</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargemAcumulado.meta) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargemAcumulado.venda) }}</td>
                      <td class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargemAcumulado.peratingimento) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargemAcumulado.margem) }}</td>
                      <td class="text-center">{{ totaisCampanhaVendaMargemAcumulado.cuponsRegra1 }}</td>
                      <td class="text-center">{{ totaisCampanhaVendaMargemAcumulado.cuponsExtras }}</td>
                      <td class="text-center">{{ totaisCampanhaVendaMargemAcumulado.totalCupons }}</td>
                    </tr>
                    </tfoot>
                  </v-simple-table>
                  </div>
                  </div>

                  <!-- VISÃO 2: AGRUPADO POR FILIAL -->
                  <div v-if="visaoTabelaCampanha === 'filial'" style="position: relative;">
                  <v-overlay :value="processandoImagem(refImagemAcumulado())" absolute opacity="0.7">
                    <div class="d-flex flex-column align-center">
                      <v-progress-circular indeterminate size="40" width="4" color="white" />
                      <div class="mt-3 text-body-2">Gerando imagem...</div>
                    </div>
                  </v-overlay>
                  <div ref="tabelaAcumuladoFilial">
                  <v-simple-table dense style="border: 1px solid #023449">
                    <thead>
                    <tr class="primary" style="height: 50px;">
                      <th class="white--text text-subtitle-2">Filial</th>
                      <th class="white--text text-center text-subtitle-2">Classificações</th>
                      <th class="white--text text-center text-subtitle-2 text-no-wrap">
                        % Participação
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon x-small color="white" class="ml-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span>% de vendedores da loja classificados (diferente de NÃO ATINGIU) sobre o total de vendedores da loja</span>
                        </v-tooltip>
                      </th>
                      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Meta Acumulada</th>
                      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Venda Acumulada</th>
                      <th class="white--text text-center text-subtitle-2">
                        % Atingimento Acumulado
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon x-small class="ml-1"
                                v-bind="attrs" v-on="on"
                                @click="mostrarValoresFinanceiros = !mostrarValoresFinanceiros"
                            >
                              <v-icon x-small color="white">{{ mostrarValoresFinanceiros ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ mostrarValoresFinanceiros ? 'Ocultar' : 'Exibir' }} venda/meta/margem</span>
                        </v-tooltip>
                      </th>
                      <th v-if="mostrarValoresFinanceiros" class="white--text text-center text-subtitle-2">Margem Acumulada</th>
                      <th class="white--text text-center text-subtitle-2">Cupons Regra 1</th>
                      <th class="white--text text-center text-subtitle-2">Cupons Extras</th>
                      <th class="white--text text-center text-subtitle-2">Total Cupons</th>
                    </tr>
                    </thead>
                    <template v-if="acumuladoAgrupadoPorFilial.length">
                    <tbody v-for="grupo in acumuladoAgrupadoPorFilial" :key="chaveGrupoFilial(grupo.idempresa)">
                    <tr
                        style="cursor: pointer;"
                        class="grey lighten-3 font-weight-bold"
                        @click="toggleGrupo(chaveGrupoFilial(grupo.idempresa))"
                    >
                      <td class="py-2 text-no-wrap" style="min-height: 40px;">
                        <div class="d-flex align-center flex-nowrap">
                          <v-icon size="18" class="mr-1">
                            {{ gruposExpandidos.has(chaveGrupoFilial(grupo.idempresa)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                          </v-icon>
                          <span class="text-no-wrap mr-2">{{ grupo.empresa }}</span>
                          <span class="text-no-wrap text-caption grey--text text--darken-1">{{ grupo.itens.length }} vendedor(es)</span>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="d-flex flex-nowrap justify-center" style="gap: 2px;">
                          <v-chip
                              v-for="resumo in classificacaoResumo(grupo.itens)"
                              :key="resumo.classificacao"
                              x-small
                              :color="resumo.qtd > 0 ? classificacaoCor(resumo.classificacao) : 'grey lighten-1'"
                            dark
                              class="font-weight-bold classificacao-medalha"
                          >
                            {{ resumo.qtd }}
                          </v-chip>
                        </div>
                      </td>
                      <td class="text-center">{{ formatarPercentual(participacaoCampanha(grupo.itens)) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.meta) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center text-no-wrap">{{ formatarMoeda(grupo.totais.venda) }}</td>
                      <td class="text-center">{{ formatarPercentual(grupo.totais.peratingimento) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(grupo.totais.margem) }}</td>
                      <td class="text-center">{{ grupo.totais.cuponsRegra1 }}</td>
                      <td class="text-center">{{ grupo.totais.cuponsExtras }}</td>
                      <td class="text-center"><strong>{{ grupo.totais.totalCupons }}</strong></td>
                    </tr>
                    <tr v-show="gruposExpandidos.has(chaveGrupoFilial(grupo.idempresa))" class="grey lighten-4" style="height: 32px;">
                      <th class="text-truncate">Vendedor</th>
                      <th class="text-center">Classificação</th>
                      <th class="text-center"></th>
                      <th v-if="mostrarValoresFinanceiros" class="text-center">Meta Acumulada</th>
                      <th v-if="mostrarValoresFinanceiros" class="text-center">Venda Acumulada</th>
                      <th class="text-center">% Atingimento Acumulado</th>
                      <th v-if="mostrarValoresFinanceiros" class="text-center">Margem Acumulada</th>
                      <th class="text-center">Cupons Regra 1</th>
                      <th class="text-center">Cupons Extras</th>
                      <th class="text-center">Total Cupons</th>
                    </tr>
                    <tr
                        v-for="item in grupo.itens"
                        v-show="gruposExpandidos.has(chaveGrupoFilial(grupo.idempresa))"
                        :key="`filial-acumulado-${item.idempresa}-${item.idvendedor}`"
                        class="font-weight-bold"
                    >
                      <td style="width:220px; max-width: 260px !important;" class="text-truncate py-1">
                        <div class="d-flex align-center text-truncate">
                          <v-tooltip v-if="item.admitido_tardiamente === 'T'" color="blue-grey" bottom max-width="280">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="18" color="amber darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
                            </template>
                            <span class="white--text">
                              Admitido após 01/10/2026: não concorre ao sorteio do prêmio OURO. Só concorre aos demais
                              sorteios (PRATA/BRONZE) se superar R$ 130.000,00 (ou a meta do mês, se for maior) em
                              todos os meses participados.
                            </span>
                          </v-tooltip>
                          <span class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</span>
                        </div>
                        <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark class="mt-1">Demitido</v-chip>
                      </td>
                      <td class="text-center">
                        <v-chip x-small :color="classificacaoCor(item.classificacao)" dark class="font-weight-bold">
                          {{ item.classificacao }}
                        </v-chip>
                      </td>
                      <td style="height: 36px !important;" class="text-center"></td>
                      <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.meta_acumulada) }}</td>
                      <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item.venda_acumulada) }}</td>
                      <td style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.peratingimento_acumulado) }}</td>
                      <td v-if="mostrarValoresFinanceiros" style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.margem_acumulada) }}</td>
                      <td style="height: 36px !important;" class="text-center">{{ item.cupons_regra1 }}</td>
                      <td style="height: 36px !important;" class="text-center">
                        <v-tooltip v-if="cuponsExtras(item) > 0" color="blue-grey" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ cuponsExtras(item) }}</span>
                          </template>
                          <div class="white--text py-1">
                            <div v-for="(bloco, idx) in cuponsExtrasBlocos(item)" :key="idx">{{ bloco }}</div>
                          </div>
                        </v-tooltip>
                        <span v-else>0</span>
                      </td>
                      <td style="height: 36px !important;" class="text-center"><strong>{{ item.total_cupons_acumulado }}</strong></td>
                    </tr>
                    </tbody>
                    </template>
                    <tbody v-else>
                    <tr>
                      <td :colspan="mostrarValoresFinanceiros ? 10 : 7" class="text-center py-4">Nenhum vendedor participante ainda.</td>
                    </tr>
                    </tbody>
                    <tfoot v-if="acumuladoAgrupadoPorFilial.length">
                    <tr class="primary white--text font-weight-bold" style="height: 40px;">
                      <td class="text-uppercase">Total ({{ campanhaVendaMargemAcumuladoFiltrado.length }} vendedores)</td>
                      <td class="text-center">
                        <div class="d-flex flex-nowrap justify-center" style="gap: 2px;">
                          <v-chip
                              v-for="resumo in classificacaoResumo(campanhaVendaMargemAcumuladoFiltrado)"
                              :key="resumo.classificacao"
                              x-small
                              :color="resumo.qtd > 0 ? classificacaoCor(resumo.classificacao) : 'grey lighten-1'"
                            dark
                              class="font-weight-bold classificacao-medalha"
                          >
                            {{ resumo.qtd }}
                          </v-chip>
                        </div>
                      </td>
                      <td class="text-center">{{ formatarPercentual(participacaoCampanha(campanhaVendaMargemAcumuladoFiltrado)) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargemAcumulado.meta) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarMoeda(totaisCampanhaVendaMargemAcumulado.venda) }}</td>
                      <td class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargemAcumulado.peratingimento) }}</td>
                      <td v-if="mostrarValoresFinanceiros" class="text-center">{{ formatarPercentual(totaisCampanhaVendaMargemAcumulado.margem) }}</td>
                      <td class="text-center">{{ totaisCampanhaVendaMargemAcumulado.cuponsRegra1 }}</td>
                      <td class="text-center">{{ totaisCampanhaVendaMargemAcumulado.cuponsExtras }}</td>
                      <td class="text-center">{{ totaisCampanhaVendaMargemAcumulado.totalCupons }}</td>
                    </tr>
                    </tfoot>
                  </v-simple-table>
                  </div>
                  </div>
                </div>
              </v-tab-item>

              <!-- ABA RESULTADO SORTEIO — versão enxuta (só o que pode ser compartilhado), pensada pra
                   apresentação: tabelas fixas por classificação (OURO/PRATA/BRONZE — NÃO ATINGIU fica de
                   fora) + modo tela cheia + exportar imagem -->
              <v-tab-item
                  v-if="permissao('dashboard_ranking_campanha_venda_margem_sorteio')"
                  key="resultado-sorteio"
                  value="resultado-sorteio"
              >
                <div v-if="carregandoVendaMargemAcumulado" class="text-center py-12">
                  <v-progress-circular :size="80" :width="8" color="primary" indeterminate>
                    <v-icon color="primary" size="40">mdi-trophy-award</v-icon>
                  </v-progress-circular>
                  <div class="mt-6 text-h6 font-weight-bold black--text">Carregando resultado do sorteio...</div>
                </div>
                <div v-else>
                  <div class="d-flex justify-space-between align-center flex-wrap mb-4" style="gap: 8px;">
                    <div class="d-flex align-center">
                      <v-icon size="18" color="#0B5C73" class="mr-2">mdi-trophy-award</v-icon>
                      <span class="text-subtitle-2 font-weight-bold" style="color: #0B5C73;">Resultado do Sorteio</span>
                    </div>
                    <div class="d-flex align-center" style="gap: 8px;">
                      <v-btn outlined color="primary" @click="dialogGerarCupons = true">
                        <v-icon left>mdi-file-pdf-box</v-icon>
                        Gerar Cupons (PDF)
                      </v-btn>
                      <v-btn color="primary" @click="abrirApresentacaoSorteio">
                        <v-icon left>mdi-presentation</v-icon>
                        Modo Apresentação
                      </v-btn>
                    </div>
                  </div>

                  <v-alert dense text type="info" icon="mdi-information-outline" class="mb-4 text-caption">
                    Se a campanha terminasse hoje: resultado parcial com base no acumulado até o momento, a
                    classificação final pode mudar até o encerramento da campanha.
                  </v-alert>

                  <div v-for="grupo in resultadoSorteioGrupos" :key="`resultado-${grupo.classificacao}`" class="mb-6">
                    <!-- NÃO ATINGIU fica oculta por padrão nessa visão (nunca aparece no modo apresentação
                         em tela cheia, de jeito nenhum — ver resultadoSorteioGruposApresentacao) -->
                    <div
                        v-if="grupo.classificacao === 'NÃO ATINGIU' && !mostrarNaoAtingiuSorteio"
                        class="d-flex justify-center"
                    >
                      <v-btn text small color="grey darken-1" @click="toggleNaoAtingiuSorteio">
                        <v-icon small left>mdi-eye-outline</v-icon>
                        Mostrar classificação NÃO ATINGIU ({{ grupo.itens.length }})
                      </v-btn>
                    </div>

                    <template v-else>
                      <div v-if="grupo.classificacao === 'NÃO ATINGIU'" class="d-flex justify-end mb-1">
                        <v-btn small icon @click="toggleNaoAtingiuSorteio">
                          <v-icon small>mdi-eye-off-outline</v-icon>
                        </v-btn>
                      </div>

                      <!-- botões de copiar/baixar ficam sobrepostos no canto da barra colorida, fora da
                           árvore capturada como imagem (irmãos do :ref, não filhos) -->
                      <div style="position: relative;">
                        <div class="d-flex align-center" style="position: absolute; top: 16px; right: 20px; height: 48px; z-index: 2;">
                          <v-tooltip v-if="!suportaCopiarImagem()" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-btn small icon disabled dark class="mr-1 resultado-sorteio-acao-btn"><v-icon small>mdi-content-copy</v-icon></v-btn>
                              </span>
                            </template>
                            <span>Seu navegador não suporta copiar imagem — use "Baixar"</span>
                          </v-tooltip>
                          <v-btn
                              v-else small icon dark class="mr-1 resultado-sorteio-acao-btn"
                              :loading="imagemProcessando === `tabelaSorteio_${grupo.classificacao}:copiar`"
                              :disabled="!!imagemProcessando"
                              @click="copiarImagemTabela(`tabelaSorteio_${grupo.classificacao}`)"
                          >
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                          <v-btn
                              small icon dark class="resultado-sorteio-acao-btn"
                              :loading="imagemProcessando === `tabelaSorteio_${grupo.classificacao}:baixar`"
                              :disabled="!!imagemProcessando"
                              @click="baixarImagemTabela(`tabelaSorteio_${grupo.classificacao}`, `resultado-sorteio-${grupo.classificacao}.png`)"
                          >
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </div>

                        <!-- tudo dentro dessa div é o que vira imagem no copiar/baixar — chip e totais
                             ficam aqui dentro, os botões de ação (acima) ficam de fora -->
                        <div :ref="`tabelaSorteio_${grupo.classificacao}`" class="pa-4" style="background: #FFFFFF;">
                          <div
                              :class="classificacaoCor(grupo.classificacao)"
                              class="d-flex align-center flex-wrap white--text px-4"
                              style="min-height: 48px; border-radius: 4px 4px 0 0;"
                          >
                            <span class="text-subtitle-1 font-weight-bold mr-4">{{ grupo.classificacao }}</span>
                            <span class="text-body-2 mr-4">{{ grupo.itens.length }} vendedor(es)</span>
                            <span class="text-body-2">Total de cupons: {{ grupo.totalCupons }}</span>
                          </div>
                          <v-simple-table dense style="border: 1px solid #023449; border-top: none; border-radius: 0;">
                          <thead>
                          <tr class="primary" style="height: 44px;">
                            <th class="white--text text-subtitle-2">Vendedor / Filial</th>
                            <th class="white--text text-center text-subtitle-2">% Atingimento Acumulado</th>
                            <th class="white--text text-center text-subtitle-2">Total de Cupons</th>
                          </tr>
                          </thead>
                          <tbody v-if="grupo.itens.length">
                          <tr v-for="item in grupo.itens" :key="`${item.idempresa}-${item.idvendedor}`" class="font-weight-bold">
                            <td style="height: 36px !important;" class="text-truncate">
                              <div class="d-flex align-center text-truncate">
                                <v-tooltip v-if="item.admitido_tardiamente === 'T'" color="blue-grey" bottom max-width="280">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" size="18" color="amber darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  <span class="white--text">
                                    Admitido após 01/10/2026: não concorre ao sorteio do prêmio OURO. Só concorre aos
                                    demais sorteios (PRATA/BRONZE) se superar R$ 130.000,00 (ou a meta do mês, se for
                                    maior) em todos os meses participados.
                                  </span>
                                </v-tooltip>
                                <span class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</span>
                              </div>
                              <div class="d-flex align-center" style="gap: 4px;">
                                <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark>Demitido</v-chip>
                                <div class="text-caption grey--text text--darken-1 text-truncate" :title="item.empresa" style="min-width: 0;">{{ item.empresa }}</div>
                              </div>
                            </td>
                            <td style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.peratingimento_acumulado) }}</td>
                            <td style="height: 36px !important;" class="text-center"><strong>{{ item.total_cupons_acumulado }}</strong></td>
                          </tr>
                          </tbody>
                          <tbody v-else>
                          <tr>
                            <td colspan="3" class="text-center py-4">Nenhum vendedor nessa classificação ainda.</td>
                          </tr>
                          </tbody>
                          </v-simple-table>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </v-tab-item>

            </v-tabs-items>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-3">
            <v-btn
                block
                color="primary"
                elevation="2"
                class="font-weight-bold"
                @click="dialogCampanhaVendaMargem = false"
            >
              <v-icon left>mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG DETALHE DE REGRA/BLOCO DA CAMPANHA VENDA E MARGEM (aberto pelo ícone dos cards totalizadores) -->
      <v-dialog v-model="dialogCampanhaVendaMargemDetalhe" max-width="900" scrollable>
        <v-card v-if="detalheBlocoCampanhaInfo">
          <v-card-title class="white--text" style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%);">
            <div class="d-flex align-center" style="width: 100%;">
              <v-icon color="white" class="mr-2" size="24">mdi-format-list-bulleted</v-icon>
              <div>
                <div class="text-h6 font-weight-bold">{{ detalheBlocoCampanhaInfo.titulo }}</div>
                <div class="text-caption" v-if="campanhaVendaMargemDetalheMes">
                  {{ campanhaVendaMargemDetalheMes.mes_formatado }} · {{ detalheBlocoCampanhaLista.length }} vendedor(es)
                </div>
              </div>
              <v-spacer />
              <v-btn icon @click="dialogCampanhaVendaMargemDetalhe = false">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider />

          <v-card-text class="black--text pt-4">
            <v-simple-table dense style="border: 1px solid #023449">
              <thead>
              <tr class="primary" style="height: 44px;">
                <th class="white--text text-subtitle-2">Vendedor / Filial</th>
                <th class="white--text text-center text-subtitle-2">{{ detalheBlocoCampanhaInfo.labelVenda }}</th>
                <th v-if="detalheBlocoCampanhaInfo.campoExtra" class="white--text text-center text-subtitle-2">{{ detalheBlocoCampanhaInfo.labelExtra }}</th>
                <th v-if="detalheBlocoCampanhaInfo.mostrarAtingimento" class="white--text text-center text-subtitle-2">% Atingimento</th>
                <th v-if="detalheBlocoCampanhaInfo.mostrarMargem" class="white--text text-center text-subtitle-2">Margem</th>
                <th class="white--text text-center text-subtitle-2">Cupons</th>
              </tr>
              </thead>
              <tbody v-if="detalheBlocoCampanhaLista.length">
              <tr v-for="item in detalheBlocoCampanhaLista" :key="`${item.idempresa}-${item.idvendedor}`" class="font-weight-bold">
                <td style="height: 36px !important; width:220px; max-width: 260px !important;" class="text-truncate">
                  <div class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</div>
                  <div class="d-flex align-center" style="gap: 4px;">
                    <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark>Demitido</v-chip>
                    <div class="text-caption grey--text text--darken-1 text-truncate" :title="item.empresa" style="min-width: 0;">{{ item.empresa }}</div>
                  </div>
                </td>
                <td style="height: 36px !important;" class="text-center text-no-wrap">{{ formatarMoeda(item[detalheBlocoCampanhaInfo.campoVenda]) }}</td>
                <td v-if="detalheBlocoCampanhaInfo.campoExtra" style="height: 36px !important;" class="text-center">
                  {{ detalheBlocoCampanhaInfo.extraFormatoMoeda ? formatarMoeda(item[detalheBlocoCampanhaInfo.campoExtra]) : item[detalheBlocoCampanhaInfo.campoExtra] }}
                </td>
                <td v-if="detalheBlocoCampanhaInfo.mostrarAtingimento" style="height: 36px !important;" class="text-center">{{ formatarPercentual(item.peratingimento) }}</td>
                <td v-if="detalheBlocoCampanhaInfo.mostrarMargem" style="height: 36px !important;" class="text-center">
                  {{ formatarPercentual(item[detalheBlocoCampanhaInfo.campoMargem || 'margem']) }}
                </td>
                <td style="height: 36px !important;" class="text-center">
                  <strong>{{ item[detalheBlocoCampanhaInfo.campo] }}</strong>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td :colspan="detalheBlocoCampanhaColunas" class="text-center py-4">
                  Nenhum vendedor pontuou nesse bloco neste mês.
                </td>
              </tr>
              </tbody>
              <tfoot v-if="detalheBlocoCampanhaLista.length">
              <tr class="primary white--text font-weight-bold" style="height: 40px;">
                <td class="text-uppercase">Total ({{ detalheBlocoCampanhaLista.length }} vendedores)</td>
                <td class="text-center text-no-wrap">{{ formatarMoeda(detalheBlocoCampanhaTotais.venda) }}</td>
                <td v-if="detalheBlocoCampanhaInfo.campoExtra" class="text-center">
                  {{ detalheBlocoCampanhaInfo.extraFormatoMoeda ? formatarMoeda(detalheBlocoCampanhaTotais.extra) : detalheBlocoCampanhaTotais.extra }}
                </td>
                <td v-if="detalheBlocoCampanhaInfo.mostrarAtingimento" class="text-center">{{ formatarPercentual(detalheBlocoCampanhaTotais.peratingimento) }}</td>
                <td v-if="detalheBlocoCampanhaInfo.mostrarMargem" class="text-center">{{ formatarPercentual(detalheBlocoCampanhaTotais.margem) }}</td>
                <td class="text-center">{{ detalheBlocoCampanhaTotais.cupons }}</td>
              </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-3">
            <v-btn
                block
                color="primary"
                elevation="2"
                class="font-weight-bold"
                @click="dialogCampanhaVendaMargemDetalhe = false"
            >
              <v-icon left>mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG MODO APRESENTAÇÃO — RESULTADO SORTEIO -->
      <v-dialog v-model="dialogResultadoSorteio" fullscreen>
        <v-card
            style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%); height: 100vh; display: flex; flex-direction: column; overflow: hidden;"
            flat tile
        >
          <div class="d-flex align-center pa-4" style="flex: 0 0 auto;">
            <v-icon color="white" class="mr-2" size="28">mdi-trophy-award</v-icon>
            <span class="white--text text-h6 font-weight-bold">Resultado Sorteio</span>
            <v-spacer />
            <span class="white--text text-subtitle-1 mr-4">{{ resultadoSorteioSlide + 1 }} / {{ resultadoSorteioGruposApresentacao.length }}</span>
            <v-btn icon @click="fecharApresentacaoSorteio">
              <v-icon color="white" size="28">mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="d-flex align-center justify-center" style="position: relative; flex: 1 1 auto; overflow: hidden; min-height: 0;">
            <v-btn icon x-large color="white" style="position: absolute; left: 16px; z-index: 2;" @click="slideAnteriorSorteio">
              <v-icon size="48">mdi-chevron-left</v-icon>
            </v-btn>

            <v-window v-model="resultadoSorteioSlide" style="width: 100%; max-width: 1100px; max-height: 100%;" touchless>
              <v-window-item v-for="(grupo, idx) in resultadoSorteioGruposApresentacao" :key="`slide-${grupo.classificacao}`" :value="idx" style="max-height: 100%;">
                <v-card class="pa-6 mx-6 apresentacao-sorteio-scroll" rounded="lg" style="max-height: calc(100vh - 112px); overflow-y: auto;">
                  <!-- botões de copiar/baixar ficam sobrepostos no canto da barra colorida, fora da árvore
                       capturada como imagem (irmãos do :ref, não filhos) -->
                  <div style="position: relative;">
                    <div class="d-flex align-center" style="position: absolute; top: 8px; right: 16px; height: 60px; z-index: 2;">
                      <v-tooltip v-if="!suportaCopiarImagem()" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <v-btn icon disabled dark class="mr-1 resultado-sorteio-acao-btn"><v-icon>mdi-content-copy</v-icon></v-btn>
                          </span>
                        </template>
                        <span>Seu navegador não suporta copiar imagem — use "Baixar"</span>
                      </v-tooltip>
                      <v-btn
                          v-else icon dark class="mr-1 resultado-sorteio-acao-btn"
                          :loading="imagemProcessando === `tabelaSorteioSlide_${grupo.classificacao}:copiar`"
                          :disabled="!!imagemProcessando"
                          @click="copiarImagemTabela(`tabelaSorteioSlide_${grupo.classificacao}`)"
                      >
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                      <v-btn
                          icon dark class="resultado-sorteio-acao-btn"
                          :loading="imagemProcessando === `tabelaSorteioSlide_${grupo.classificacao}:baixar`"
                          :disabled="!!imagemProcessando"
                          @click="baixarImagemTabela(`tabelaSorteioSlide_${grupo.classificacao}`, `resultado-sorteio-${grupo.classificacao}.png`)"
                      >
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </div>

                    <!-- tudo dentro dessa div é o que vira imagem no copiar/baixar — chip e totais ficam
                         aqui dentro, os botões de ação (acima) ficam de fora -->
                    <div :ref="`tabelaSorteioSlide_${grupo.classificacao}`" class="pa-2" style="background: #FFFFFF;">
                      <div
                          :class="classificacaoCor(grupo.classificacao)"
                          class="d-flex align-center flex-wrap white--text px-5"
                          style="min-height: 60px; border-radius: 4px 4px 0 0;"
                      >
                        <span class="text-h6 font-weight-bold mr-5">{{ grupo.classificacao }}</span>
                        <span class="text-subtitle-1 mr-5">{{ grupo.itens.length }} vendedor(es)</span>
                        <span class="text-subtitle-1">Total de cupons: {{ grupo.totalCupons }}</span>
                      </div>
                      <v-simple-table :dense="grupo.itens.length > 12" style="border: 1px solid #023449; border-top: none; border-radius: 0;">
                      <thead>
                      <tr class="primary" :style="`height: ${linhaAlturaSlideApresentacao(grupo.itens.length) + 8}px;`">
                        <th class="white--text text-subtitle-1">Vendedor / Filial</th>
                        <th class="white--text text-center text-subtitle-1">% Atingimento Acumulado</th>
                        <th class="white--text text-center text-subtitle-1">Total de Cupons</th>
                      </tr>
                      </thead>
                      <tbody v-if="grupo.itens.length">
                      <tr v-for="item in grupo.itens" :key="`slide-item-${item.idempresa}-${item.idvendedor}`" class="font-weight-bold">
                        <td :style="`height: ${linhaAlturaSlideApresentacao(grupo.itens.length)}px !important;`" :class="['text-truncate', fonteSlideApresentacao(grupo.itens.length)]">
                          <div class="d-flex align-center text-truncate">
                            <v-tooltip v-if="item.admitido_tardiamente === 'T'" color="blue-grey" bottom max-width="280">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" size="22" color="amber darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
                              </template>
                              <span class="white--text">
                                Admitido após 01/10/2026: não concorre ao sorteio do prêmio OURO. Só concorre aos
                                demais sorteios (PRATA/BRONZE) se superar R$ 130.000,00 (ou a meta do mês, se for
                                maior) em todos os meses participados.
                              </span>
                            </v-tooltip>
                            <span class="text-truncate" :title="limparNomeVendedor(item.vendedor)">{{ limparNomeVendedor(item.vendedor) }}</span>
                          </div>
                          <div class="d-flex align-center" style="gap: 4px;">
                            <v-chip v-if="item.vendedor_demitido" x-small color="grey darken-1" dark>Demitido</v-chip>
                            <div class="text-caption grey--text text--darken-1 text-truncate" :title="item.empresa" style="min-width: 0;">{{ item.empresa }}</div>
                          </div>
                        </td>
                        <td :style="`height: ${linhaAlturaSlideApresentacao(grupo.itens.length)}px !important;`" :class="['text-center', fonteSlideApresentacao(grupo.itens.length)]">{{ formatarPercentual(item.peratingimento_acumulado) }}</td>
                        <td :style="`height: ${linhaAlturaSlideApresentacao(grupo.itens.length)}px !important;`" :class="['text-center', fonteSlideApresentacao(grupo.itens.length)]"><strong>{{ item.total_cupons_acumulado }}</strong></td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                      <tr>
                        <td colspan="3" class="text-center py-8 text-body-1">Nenhum vendedor nessa classificação ainda.</td>
                      </tr>
                      </tbody>
                      </v-simple-table>
                    </div>
                  </div>
                </v-card>
              </v-window-item>
            </v-window>

            <v-btn icon x-large color="white" style="position: absolute; right: 16px; z-index: 2;" @click="proximoSlideSorteio">
              <v-icon size="48">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- Dialog: opções de layout pro PDF de cupons do sorteio -->
      <v-dialog v-model="dialogGerarCupons" max-width="600">
        <v-card>
          <v-card-title>
            <v-icon left color="primary">mdi-file-pdf-box</v-icon>
            Gerar Cupons do Sorteio
          </v-card-title>
          <v-card-text>
            <div class="mb-4">
              Serão gerados <strong>{{ totalCuponsSorteio }}</strong> cupons, um por cupom acumulado de cada
              vendedor elegível (OURO, PRATA e BRONZE), prontos pra imprimir em A4 e recortar.
            </div>

            <div class="text-subtitle-2 font-weight-bold mb-2">Tamanho do cupom</div>
            <v-radio-group v-model="cupomLayoutSelecionado" class="mt-0" hide-details>
              <v-radio value="compacto">
                <template v-slot:label>
                  <div>
                    <strong>Compacto</strong>, 5 x 11, 55 cupons/página, ~39mm x 26mm
                  </div>
                </template>
              </v-radio>
              <v-radio value="medio">
                <template v-slot:label>
                  <div>
                    <strong>Médio</strong>, 4 x 8, 32 cupons/página, ~49mm x 35mm
                  </div>
                </template>
              </v-radio>
              <v-radio value="grande">
                <template v-slot:label>
                  <div>
                    <strong>Grande</strong>, 3 x 6, 18 cupons/página, ~66mm x 47mm
                  </div>
                </template>
              </v-radio>
            </v-radio-group>

            <v-alert dense text type="info" class="mt-4 mb-0 text-caption">
              ≈ {{ cupomTotalPaginasEstimado }} páginas.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogGerarCupons = false">Cancelar</v-btn>
            <v-btn color="primary" @click="gerarCuponsSorteio">
              <v-icon left small>mdi-file-pdf-box</v-icon>
              Gerar PDF
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog: progresso da geração do PDF de cupons -->
      <v-dialog v-model="carregandoPdf" persistent overlay-opacity="0.7" width="400">
        <v-card class="pa-6 text-center">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
          <div class="mt-4">{{ carregandoPdfMensagem }}</div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbarImagem.show" :color="snackbarImagem.color" timeout="3000">
        {{ snackbarImagem.text }}
      </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CardDashboard from "../Widgets/CardDashboard";
import SeletorPeriodoMes from "../UI/Inputs/SeletorPeriodoMes";

// período da campanha (aaaa-mm), mesmo intervalo do backend (campanhaVendaMargemInicio/Fim)
const CAMPANHA_MES_INICIO = '2026-07';
const CAMPANHA_MES_FIM = '2026-12';

const mesAtualCampanha = () => {
  const hoje = new Date();
  const mes = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
  return mes < CAMPANHA_MES_INICIO ? CAMPANHA_MES_INICIO : mes > CAMPANHA_MES_FIM ? CAMPANHA_MES_FIM : mes;
};

// último mês já fechado (mês anterior ao corrente), limitado ao período da campanha
const ultimoMesFechadoCampanha = () => {
  const [ano, mes] = mesAtualCampanha().split('-').map(Number);
  const anterior = mes === 1 ? `${ano - 1}-12` : `${ano}-${String(mes - 1).padStart(2, '0')}`;
  return anterior < CAMPANHA_MES_INICIO ? CAMPANHA_MES_INICIO : anterior;
};

// Configurações dos layouts de cupom pro PDF de impressão do sorteio — mesmo padrão de
// ETIQUETAS_CONFIG em EtiquetasDepositoGerarPdf.vue: getters calculam o tamanho de cada
// cupom a partir da A4, margens e espaçamento, pra grade sempre encaixar certinho na folha.
const CUPOM_LAYOUTS = {
  compacto: {
    titulo: 'Compacto',
    A4_WIDTH: 210, A4_HEIGHT: 297,
    COLS: 5, ROWS: 11,
    MARGIN_LEFT: 5, MARGIN_RIGHT: 5, MARGIN_TOP: 6, MARGIN_BOTTOM: 6,
    SPACING_X: 2, SPACING_Y: 1,
    get CUPONS_POR_PAGINA() { return this.COLS * this.ROWS; },
    get CUPOM_WIDTH() { return (this.A4_WIDTH - this.MARGIN_LEFT - this.MARGIN_RIGHT - this.SPACING_X * (this.COLS - 1)) / this.COLS; },
    get CUPOM_HEIGHT() { return (this.A4_HEIGHT - this.MARGIN_TOP - this.MARGIN_BOTTOM - this.SPACING_Y * (this.ROWS - 1)) / this.ROWS; }
  },
  medio: {
    titulo: 'Médio',
    A4_WIDTH: 210, A4_HEIGHT: 297,
    COLS: 4, ROWS: 8,
    MARGIN_LEFT: 5, MARGIN_RIGHT: 5, MARGIN_TOP: 6, MARGIN_BOTTOM: 6,
    SPACING_X: 2, SPACING_Y: 1,
    get CUPONS_POR_PAGINA() { return this.COLS * this.ROWS; },
    get CUPOM_WIDTH() { return (this.A4_WIDTH - this.MARGIN_LEFT - this.MARGIN_RIGHT - this.SPACING_X * (this.COLS - 1)) / this.COLS; },
    get CUPOM_HEIGHT() { return (this.A4_HEIGHT - this.MARGIN_TOP - this.MARGIN_BOTTOM - this.SPACING_Y * (this.ROWS - 1)) / this.ROWS; }
  },
  grande: {
    titulo: 'Grande',
    A4_WIDTH: 210, A4_HEIGHT: 297,
    COLS: 3, ROWS: 6,
    MARGIN_LEFT: 5, MARGIN_RIGHT: 5, MARGIN_TOP: 6, MARGIN_BOTTOM: 6,
    SPACING_X: 2, SPACING_Y: 1,
    get CUPONS_POR_PAGINA() { return this.COLS * this.ROWS; },
    get CUPOM_WIDTH() { return (this.A4_WIDTH - this.MARGIN_LEFT - this.MARGIN_RIGHT - this.SPACING_X * (this.COLS - 1)) / this.COLS; },
    get CUPOM_HEIGHT() { return (this.A4_HEIGHT - this.MARGIN_TOP - this.MARGIN_BOTTOM - this.SPACING_Y * (this.ROWS - 1)) / this.ROWS; }
  },
};

export default {
  name: "CampanhaVendaMargem",
  components: { CardDashboard, SeletorPeriodoMes },
  data() {
    return {
    dialogCampanhaVendaMargem: false,
    // o dialog abre direto no Acumulado Geral (e não no mês corrente)
    abaCampanhaVendaMargem: 'acumulado',
    carregandoVendaMargem: false,
    carregandoVendaMargemAcumulado: false,
    campanhaVendaMargemMeses: [],
    campanhaVendaMargemAcumulado: [],
    // acumulado da aba "Acumulado Geral" (filtrado por período); campanhaVendaMargemAcumulado segue completo pro sorteio
    campanhaVendaMargemAcumuladoFiltrado: [],
    carregandoAcumuladoFiltrado: false,
    filtroAcumuladoInicio: CAMPANHA_MES_INICIO,
    filtroAcumuladoFim: ultimoMesFechadoCampanha(),
    gruposExpandidos: new Set(),
    painelTotalizadoresCampanha: 0,
    totalizadoresAcumuladoAberto: true,
    visaoTabelaCampanha: 'classificacao',
    dialogCampanhaVendaMargemDetalhe: false,
    campanhaVendaMargemDetalheMes: null,
    campanhaVendaMargemDetalheChave: null,
    dialogResultadoSorteio: false,
    resultadoSorteioSlide: 0,
    mostrarNaoAtingiuSorteio: false,
    mostrarValoresFinanceiros: true,
    snackbarImagem: { show: false, text: '', color: 'success' },
    // chave `${refName}:copiar` ou `${refName}:baixar` da imagem sendo gerada agora (só uma por vez) — usada
    // pra mostrar o spinner de carregamento no botão certo e bloquear cliques duplicados enquanto o
    // html2canvas roda (é síncrono e pode travar a tela por um instante em tabelas grandes)
    imagemProcessando: null,
    dialogGerarCupons: false,
    cupomLayoutSelecionado: 'medio',
    carregandoPdf: false,
    carregandoPdfMensagem: '',
    };
  },
  computed: {
    ...mapState(["backendUrl"]),
    detalheBlocoCampanhaInfo() {
      return this.campanhaVendaMargemDetalheChave
          ? this.campanhaVendaMargemBlocoInfo(this.campanhaVendaMargemDetalheChave)
          : null;
    },

    detalheBlocoCampanhaLista() {
      const info = this.detalheBlocoCampanhaInfo;
      if (!info || !this.campanhaVendaMargemDetalheMes) return [];
      const lista = (this.campanhaVendaMargemDetalheMes.lista || []).filter((item) => (item[info.campo] || 0) > 0);
      // desempate (todo mundo do bloco tem o mesmo tanto de cupons): usa o critério real de ranking do
      // bloco (ex: pontos no Bloco C), não a venda — venda é só informativa em blocos que não rankeiam por ela
      const campoDesempate = info.campoOrdenacao || info.campoVenda;
      return [...lista].sort((a, b) => (b[info.campo] || 0) - (a[info.campo] || 0) || (b[campoDesempate] || 0) - (a[campoDesempate] || 0));
    },

    detalheBlocoCampanhaColunas() {
      const info = this.detalheBlocoCampanhaInfo;
      if (!info) return 3;
      // Vendedor/Filial + Venda + Cupons, mais Extra/Atingimento/Margem quando aplicável
      return 3 + (info.campoExtra ? 1 : 0) + (info.mostrarAtingimento ? 1 : 0) + (info.mostrarMargem ? 1 : 0);
    },

    detalheBlocoCampanhaTotais() {
      const info = this.detalheBlocoCampanhaInfo;
      if (!info) return { cupons: 0, venda: 0, extra: 0, peratingimento: 0, margem: 0 };

      const base = this.detalheBlocoCampanhaLista.reduce((acc, item) => {
        const venda = item[info.campoVenda] || 0;
        acc.cupons += item[info.campo] || 0;
        acc.venda += venda;
        acc.extra += item[info.campoExtra] || 0;
        acc.meta += item.meta || 0;
        acc.lucroEstimado += venda * (item[info.campoMargem || 'margem'] || 0) / 100;
        return acc;
      }, { cupons: 0, venda: 0, extra: 0, meta: 0, lucroEstimado: 0 });

      base.peratingimento = base.meta > 0 ? (base.venda / base.meta) * 100 : 0;
      base.margem = base.venda > 0 ? (base.lucroEstimado / base.venda) * 100 : 0;
      return base;
    },
    periodoPadraoAcumulado() {
      return { inicio: CAMPANHA_MES_INICIO, fim: ultimoMesFechadoCampanha() };
    },
    // da abertura da campanha até o mês corrente (incluindo o mês ainda em aberto)
    periodoCampanhaTodaAcumulado() {
      return { inicio: CAMPANHA_MES_INICIO, fim: mesAtualCampanha() };
    },
    atalhosPeriodoAcumulado() {
      return [
        { label: 'Meses fechados', ...this.periodoPadraoAcumulado },
        { label: 'Até hoje', ...this.periodoCampanhaTodaAcumulado },
      ];
    },
    totaisCampanhaVendaMargemAcumulado() {
      return this.totaisAcumulado(this.campanhaVendaMargemAcumuladoFiltrado);
    },

    // agrupa o acumulado por classificação (OURO/PRATA/BRONZE/NÃO ATINGIU) — mesma classificação da Regra 1
    // mensal, calculada só a partir do % de atingimento acumulado (margem acumulada é só informativa)
    acumuladoAgrupado() {
      const ordenado = this.acumuladoOrdenado(this.campanhaVendaMargemAcumuladoFiltrado);
      const grupos = [];
      const porClassificacao = {};
      ordenado.forEach((item) => {
        const classificacao = item.classificacao || 'NÃO ATINGIU';
        if (!porClassificacao[classificacao]) {
          porClassificacao[classificacao] = { classificacao, itens: [] };
          grupos.push(porClassificacao[classificacao]);
        }
        porClassificacao[classificacao].itens.push(item);
      });
      return grupos.map((grupo) => ({
        ...grupo,
        totais: this.totaisAcumulado(grupo.itens),
      }));
    },

    // agrupa o acumulado por filial — mesma ideia de mesAgrupadoPorFilial, mas sobre o total acumulado
    acumuladoAgrupadoPorFilial() {
      const grupos = [];
      const porFilial = {};
      (this.campanhaVendaMargemAcumuladoFiltrado || []).forEach((item) => {
        const chave = item.idempresa;
        if (!porFilial[chave]) {
          porFilial[chave] = { idempresa: item.idempresa, empresa: item.empresa, itens: [] };
          grupos.push(porFilial[chave]);
        }
        porFilial[chave].itens.push(item);
      });
      return grupos
          .map((grupo) => ({
            ...grupo,
            itens: this.acumuladoOrdenado(grupo.itens),
            totais: this.totaisAcumulado(grupo.itens),
          }))
          .sort((a, b) => (a.empresa || '').localeCompare(b.empresa || ''));
    },

    // resultado do sorteio pra aba (visão normal, não tela cheia) — fixo nas 4 classificações (mesmo vazia)
    // pra manter a ordem e o formato previsíveis, com NÃO ATINGIU por último e oculta por padrão (ver
    // mostrarNaoAtingiuSorteio/toggleNaoAtingiuSorteio)
    resultadoSorteioGrupos() {
      const ordem = ['OURO', 'PRATA', 'BRONZE', 'NÃO ATINGIU'];
      return ordem.map((classificacao) => {
        const itens = this.acumuladoOrdenado(
            (this.campanhaVendaMargemAcumulado || []).filter((item) => (item.classificacao || 'NÃO ATINGIU') === classificacao)
        );
        const totalCupons = itens.reduce((soma, item) => soma + (item.total_cupons_acumulado || 0), 0);
        return { classificacao, itens, totalCupons };
      });
    },

    // resultado do sorteio pro modo apresentação (tela cheia) — NÃO ATINGIU nunca aparece aqui, sem exceção
    resultadoSorteioGruposApresentacao() {
      return this.resultadoSorteioGrupos.filter((grupo) => grupo.classificacao !== 'NÃO ATINGIU');
    },

    // total de cupons físicos que serão gerados no PDF do sorteio — soma de todos os vendedores elegíveis
    // (mesma base do modo apresentação, NÃO ATINGIU nunca entra aqui)
    totalCuponsSorteio() {
      return this.resultadoSorteioGruposApresentacao.reduce((soma, grupo) => soma + grupo.totalCupons, 0);
    },

    // estimativa de páginas do PDF de cupons pro layout selecionado no dialog — usado só pra exibir
    // "≈ X páginas" antes de gerar de fato
    cupomLayoutConfig() {
      return CUPOM_LAYOUTS[this.cupomLayoutSelecionado];
    },

    cupomTotalPaginasEstimado() {
      if (!this.totalCuponsSorteio) return 0;
      return Math.ceil(this.totalCuponsSorteio / this.cupomLayoutConfig.CUPONS_POR_PAGINA);
    },
  },
  methods: {
    // ------------------

    // funções somente para campanha venda e margem
    // (classificacaoCor/classificacaoCorRGB moraram aqui antes; foram pro globalMixin.js pra serem
    // reaproveitadas também pela visão do vendedor em DashboardVendas.vue)

    // versão bem clara (mesclada com branco) da cor da classificação — usada como fundo do cupom, pra dar
    // pra separar visualmente as classificações mesmo depois de cortados e espalhados
    classificacaoCorClaraRGB(classificacao) {
      const [r, g, b] = this.classificacaoCorRGB(classificacao);
      const clarear = (c) => Math.round(255 + (c - 255) * 0.12);
      return [clarear(r), clarear(g), clarear(b)];
    },

    // remove telefone/lixo colado no fim do nome do vendedor, vindo sujo do cadastro do ERP — tira, de trás
    // pra frente, qualquer "palavra" (separada por espaço) que tenha dígito ou não tenha nenhuma letra,
    // parando assim que encontra uma palavra de verdade (nome não tem número, então é sempre seguro)
    // (ex: "ANTONIO CARLOS RECHE BASSI (44) 9 9924-0333" -> "ANTONIO CARLOS RECHE BASSI",
    //      "MARCIA VENDRAMINI 44-99923-2891" -> "MARCIA VENDRAMINI", "JOAO FABIO 123 -000" -> "JOAO FABIO")
    limparNomeVendedor(nome) {
      if (!nome) return '';
      const palavras = nome.trim().split(/\s+/);
      while (palavras.length > 1) {
        const ultima = palavras[palavras.length - 1];
        const temDigito = /\d/.test(ultima);
        const temLetra = /[A-Za-zÀ-ÖØ-öø-ÿ]/.test(ultima);
        if (temDigito || !temLetra) {
          palavras.pop();
        } else {
          break;
        }
      }
      return palavras.join(' ').trim();
    },

    // resumo (contagem por classificação) de uma lista de vendedores — usado na visão por filial pra mostrar
    // quantos vendedores de cada classificação tem naquela filial, num chip colorido cada
    classificacaoResumo(itens) {
      const ordem = ['OURO', 'PRATA', 'BRONZE', 'NÃO ATINGIU'];
      const contagem = {};
      (itens || []).forEach((item) => {
        const classificacao = item.classificacao || 'NÃO ATINGIU';
        contagem[classificacao] = (contagem[classificacao] || 0) + 1;
      });
      return ordem.map((classificacao) => ({ classificacao, qtd: contagem[classificacao] || 0 }));
    },

    // % de vendedores classificados (diferente de NÃO ATINGIU) sobre o total de vendedores da lista —
    // usado na visão por filial como indicador de engajamento da loja na campanha
    participacaoCampanha(itens) {
      if (!itens || !itens.length) return 0;
      const classificados = itens.filter((item) => (item.classificacao || 'NÃO ATINGIU') !== 'NÃO ATINGIU').length;
      return (classificados / itens.length) * 100;
    },

    cuponsExtras(item) {
      return (item.cupons_bloco_a || 0) + (item.cupons_bloco_b || 0) + (item.cupons_bloco_c || 0) + (item.cupons_bloco_d || 0) + (item.cupons_bloco_e || 0) + (item.cupons_bloco_f || 0);
    },

    cuponsExtrasBlocos(item) {
      const blocos = [];
      if (item.cupons_bloco_a) blocos.push(`Bloco A (maior venda da rede): ${item.cupons_bloco_a}`);
      if (item.cupons_bloco_b) blocos.push(`Bloco B (maior venda da filial): ${item.cupons_bloco_b}`);
      if (item.cupons_bloco_c) blocos.push(`Bloco C (top 10 Educa e-book): ${item.cupons_bloco_c}`);
      if (item.cupons_bloco_d) blocos.push(`Bloco D (produto sem giro): ${item.cupons_bloco_d}`);
      if (item.cupons_bloco_e) blocos.push(`Bloco E (margem + atingimento individual): ${item.cupons_bloco_e}`);
      if (item.cupons_bloco_f) blocos.push(`Bloco F (meta trimestral): ${item.cupons_bloco_f}`);
      return blocos.length ? blocos : ['Sem cupons extras'];
    },

    mesOrdenado(lista) {
      const ordemClassificacao = { OURO: 1, PRATA: 2, BRONZE: 3 };
      const rankClassificacao = (classificacao) => ordemClassificacao[classificacao] || 4;
      return [...(lista || [])].sort((a, b) => {
        const diffClassificacao = rankClassificacao(a.classificacao) - rankClassificacao(b.classificacao);
        if (diffClassificacao !== 0) return diffClassificacao;
        return (b.total_cupons || 0) - (a.total_cupons || 0);
      });
    },

    totaisCampanhaVendaMargem(lista) {
      const base = (lista || []).reduce((acc, item) => {
        acc.venda += item.venda || 0;
        acc.meta += item.meta || 0;
        acc.lucroEstimado += (item.venda || 0) * (item.margem || 0) / 100;
        acc.cuponsRegra1 += item.cupons_regra1 || 0;
        acc.cuponsExtras += this.cuponsExtras(item);
        acc.totalCupons += item.total_cupons || 0;
        return acc;
      }, { venda: 0, meta: 0, lucroEstimado: 0, cuponsRegra1: 0, cuponsExtras: 0, totalCupons: 0 });

      base.peratingimento = base.meta > 0 ? (base.venda / base.meta) * 100 : 0;
      base.margem = base.venda > 0 ? (base.lucroEstimado / base.venda) * 100 : 0;
      return base;
    },

    mesAgrupado(lista) {
      const ordenado = this.mesOrdenado(lista);
      const grupos = [];
      const porClassificacao = {};
      ordenado.forEach((item) => {
        const classificacao = item.classificacao || 'NÃO ATINGIU';
        if (!porClassificacao[classificacao]) {
          porClassificacao[classificacao] = { classificacao, itens: [] };
          grupos.push(porClassificacao[classificacao]);
        }
        porClassificacao[classificacao].itens.push(item);
      });
      return grupos.map((grupo) => ({
        ...grupo,
        totais: this.totaisCampanhaVendaMargem(grupo.itens),
      }));
    },

    chaveGrupo(mes, classificacao) {
      return `${mes}-${classificacao}`;
    },

    mesAgrupadoPorFilial(lista) {
      const grupos = [];
      const porFilial = {};
      (lista || []).forEach((item) => {
        const chave = item.idempresa;
        if (!porFilial[chave]) {
          porFilial[chave] = { idempresa: item.idempresa, empresa: item.empresa, itens: [] };
          grupos.push(porFilial[chave]);
        }
        porFilial[chave].itens.push(item);
      });
      return grupos
          .map((grupo) => ({
            ...grupo,
            itens: this.mesOrdenado(grupo.itens),
            totais: this.totaisCampanhaVendaMargem(grupo.itens),
          }))
          .sort((a, b) => (a.empresa || '').localeCompare(b.empresa || ''));
    },

    // sem o mês na chave de propósito — assim expandir/ocultar uma filial vale pra todos os meses e
    // pro acumulado ao mesmo tempo, já que compartilham o mesmo gruposExpandidos
    chaveGrupoFilial(idempresa) {
      return `filial-${idempresa}`;
    },

    totaisAcumulado(lista) {
      const base = (lista || []).reduce((acc, item) => {
        acc.venda += item.venda_acumulada || 0;
        acc.meta += item.meta_acumulada || 0;
        acc.lucroEstimado += (item.venda_acumulada || 0) * (item.margem_acumulada || 0) / 100;
        acc.totalCupons += item.total_cupons_acumulado || 0;
        acc.cuponsRegra1 += item.cupons_regra1 || 0;
        acc.cuponsBlocoA += item.cupons_bloco_a || 0;
        acc.cuponsBlocoB += item.cupons_bloco_b || 0;
        acc.cuponsBlocoC += item.cupons_bloco_c || 0;
        acc.cuponsBlocoD += item.cupons_bloco_d || 0;
        acc.cuponsBlocoE += item.cupons_bloco_e || 0;
        acc.cuponsBlocoF += item.cupons_bloco_f || 0;
        acc.cuponsExtras += this.cuponsExtras(item);
        return acc;
      }, {
        venda: 0, meta: 0, lucroEstimado: 0, totalCupons: 0,
        cuponsRegra1: 0, cuponsBlocoA: 0, cuponsBlocoB: 0, cuponsBlocoC: 0, cuponsBlocoD: 0, cuponsBlocoE: 0, cuponsBlocoF: 0,
        cuponsExtras: 0,
      });

      base.peratingimento = base.meta > 0 ? (base.venda / base.meta) * 100 : 0;
      base.margem = base.venda > 0 ? (base.lucroEstimado / base.venda) * 100 : 0;
      return base;
    },

    acumuladoOrdenado(lista) {
      const ordemClassificacao = { OURO: 1, PRATA: 2, BRONZE: 3 };
      const rankClassificacao = (classificacao) => ordemClassificacao[classificacao] || 4;
      return [...(lista || [])].sort((a, b) => {
        const diffClassificacao = rankClassificacao(a.classificacao) - rankClassificacao(b.classificacao);
        if (diffClassificacao !== 0) return diffClassificacao;
        return (b.total_cupons_acumulado || 0) - (a.total_cupons_acumulado || 0);
      });
    },

    chaveGrupoAcumulado(classificacao) {
      return `acumulado-${classificacao}`;
    },

    // --- Resultado Sorteio: cupons físicos em PDF (impressão A4) ---

    // achata os grupos de resultadoSorteioGruposApresentacao numa lista de cupons individuais, um por
    // cupom acumulado de cada vendedor (ex: vendedor com 40 cupons gera 40 entradas), numerados em
    // sequência global (1..N, sem reiniciar por vendedor) — esse número é o usado fisicamente no sorteio
    listaCuponsAchatada() {
      const cupons = [];
      let numero = 0;
      this.resultadoSorteioGruposApresentacao.forEach((grupo) => {
        grupo.itens.forEach((item) => {
          const qtd = item.total_cupons_acumulado || 0;
          for (let i = 0; i < qtd; i++) {
            numero++;
            cupons.push({ numero, vendedor: this.limparNomeVendedor(item.vendedor), idvendedor: item.idvendedor, empresa: item.empresa, classificacao: grupo.classificacao });
          }
        });
      });
      return cupons;
    },

    // desenha um cupom individual no PDF (vetor, sem imagem nenhuma) — borda pra guia de corte, faixa
    // colorida da classificação no topo, número grande do cupom e vendedor/filial embaixo
    desenharCupom(pdf, cupom, x, y, config, totalCupons) {
      // escala tudo (faixa, fontes, respiros) proporcional à altura do cupom, usando o Compacto como
      // referência — sem isso, fontes fixas ficavam do mesmo tamanho no Médio e no Grande
      const escala = config.CUPOM_HEIGHT / CUPOM_LAYOUTS.compacto.CUPOM_HEIGHT;
      const raio = Math.min(1.4 * escala, config.CUPOM_HEIGHT / 8, config.CUPOM_WIDTH / 8);

      // fundo com tom bem claro da classificação — ajuda a separar visualmente as pilhas depois de
      // cortado, sem pesar a impressão (cor concentrada só na faixa do topo)
      const [claroR, claroG, claroB] = this.classificacaoCorClaraRGB(cupom.classificacao);
      pdf.setFillColor(claroR, claroG, claroB);
      pdf.roundedRect(x, y, config.CUPOM_WIDTH, config.CUPOM_HEIGHT, raio, raio, 'F');

      // borda pontilhada — guia de corte, discreta (cinza, não preta)
      pdf.setDrawColor(140, 140, 140);
      pdf.setLineWidth(0.12);
      pdf.setLineDashPattern([0.8, 0.8], 0);
      pdf.roundedRect(x, y, config.CUPOM_WIDTH, config.CUPOM_HEIGHT, raio, raio, 'S');
      pdf.setLineDashPattern([], 0);

      // faixa sólida da classificação, no topo
      const faixaAltura = 4.5 * escala;
      const [corR, corG, corB] = this.classificacaoCorRGB(cupom.classificacao);
      pdf.setFillColor(corR, corG, corB);
      pdf.rect(x, y, config.CUPOM_WIDTH, faixaAltura, 'F');
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(6 * escala);
      pdf.setFont('helvetica', 'bold');
      pdf.text(cupom.classificacao, x + config.CUPOM_WIDTH / 2, y + faixaAltura - 1.3 * escala, { align: 'center', charSpace: 0.3 });

      // número do cupom — rótulo pequeno acima, número grande em destaque (cor da marca)
      const centroY = y + faixaAltura + (config.CUPOM_HEIGHT - faixaAltura) * 0.42;
      pdf.setTextColor(120, 120, 120);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(4 * escala);
      pdf.text('CUPOM Nº', x + config.CUPOM_WIDTH / 2, centroY - 4.2 * escala, { align: 'center', charSpace: 0.3 });

      const digitos = String(totalCupons).length;
      const numeroFormatado = String(cupom.numero).padStart(digitos, '0');
      pdf.setTextColor(2, 52, 73); // navy da marca
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(13 * escala);
      pdf.text(numeroFormatado, x + config.CUPOM_WIDTH / 2, centroY, { align: 'center' });

      // linha fina separando o número do nome do vendedor
      pdf.setDrawColor(205, 205, 205);
      pdf.setLineWidth(0.1);
      const divisorY = centroY + 2.4 * escala;
      pdf.line(x + config.CUPOM_WIDTH * 0.18, divisorY, x + config.CUPOM_WIDTH * 0.82, divisorY);

      pdf.setTextColor(40, 40, 40);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6 * escala);
      const maxWidth = config.CUPOM_WIDTH - 4;
      const linhasVendedor = pdf.splitTextToSize((cupom.vendedor || '').toUpperCase(), maxWidth).slice(0, 2);
      pdf.text(linhasVendedor, x + config.CUPOM_WIDTH / 2, y + config.CUPOM_HEIGHT - 6 * escala, { align: 'center' });

      pdf.setTextColor(110, 110, 110);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(5.5 * escala);
      // ID do vendedor junto da filial — ajuda a identificar o ganhador sem ambiguidade (nomes repetidos
      // entre filiais, por ex). O ID é sempre exibido inteiro (é curto e é a informação que importa); quem
      // trunca quando o nome da filial é grande é a FILIAL, não o ID — antes era o contrário e o ID sumia
      // em filiais com nome comprido (ex: "São João do Triunfo Loja")
      const sufixoId = `  ·  ID ${cupom.idvendedor ?? '-'}`;
      const larguraSufixo = pdf.getTextWidth(sufixoId);
      const larguraEmpresa = Math.max(maxWidth - larguraSufixo, 0);
      const linhasEmpresa = pdf.splitTextToSize(cupom.empresa || '', larguraEmpresa);
      const empresaAjustada = linhasEmpresa.length > 1 ? `${linhasEmpresa[0]}…` : (linhasEmpresa[0] || '');
      pdf.text(`${empresaAjustada}${sufixoId}`, x + config.CUPOM_WIDTH / 2, y + config.CUPOM_HEIGHT - 1.6 * escala, { align: 'center' });
    },

    // gera o PDF de cupons do sorteio inteiro num único documento — desenho vetorial puro (sem
    // html2canvas), página por página, seguindo o mesmo padrão de EtiquetasDepositoGerarPdf.vue
    async gerarCuponsSorteio() {
      this.dialogGerarCupons = false;
      this.carregandoPdf = true;
      this.carregandoPdfMensagem = 'Montando lista de cupons...';

      try {
        const dados = this.listaCuponsAchatada();
        if (!dados.length) {
          this.carregandoPdf = false;
          return;
        }

        const config = this.cupomLayoutConfig;
        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true });
        const totalPaginas = Math.ceil(dados.length / config.CUPONS_POR_PAGINA);

        for (let pagina = 0; pagina < totalPaginas; pagina++) {
          if (pagina > 0) pdf.addPage();

          const startIndex = pagina * config.CUPONS_POR_PAGINA;
          const endIndex = Math.min(startIndex + config.CUPONS_POR_PAGINA, dados.length);
          this.carregandoPdfMensagem = `Gerando página ${pagina + 1} de ${totalPaginas}...`;

          for (let i = startIndex; i < endIndex; i++) {
            const idx = i - startIndex;
            const row = Math.floor(idx / config.COLS);
            const col = idx % config.COLS;
            const x = config.MARGIN_LEFT + col * (config.CUPOM_WIDTH + config.SPACING_X);
            const y = config.MARGIN_TOP + row * (config.CUPOM_HEIGHT + config.SPACING_Y);
            this.desenharCupom(pdf, dados[i], x, y, config, dados.length);
          }

          if (pagina % 5 === 0) {
            await new Promise((resolve) => setTimeout(resolve, 10));
          }
        }

        const agora = new Date();
        const timestamp = agora.toISOString().replace(/[:.]/g, '-').slice(0, -5);
        pdf.save(`Cupons_Sorteio_${timestamp}.pdf`);
      } finally {
        this.carregandoPdf = false;
        this.carregandoPdfMensagem = '';
      }
    },

    // --- Resultado Sorteio: modo apresentação (tela cheia) ---

    abrirApresentacaoSorteio() {
      this.resultadoSorteioSlide = 0;
      this.dialogResultadoSorteio = true;
    },

    toggleNaoAtingiuSorteio() {
      this.mostrarNaoAtingiuSorteio = !this.mostrarNaoAtingiuSorteio;
    },

    // densidade da tabela no slide do modo apresentação — quanto mais gente na classificação, mais compacta
    // a linha fica, pra caber inteira na tela sem precisar rolar
    linhaAlturaSlideApresentacao(qtd) {
      if (qtd > 25) return 28;
      if (qtd > 18) return 32;
      if (qtd > 12) return 38;
      if (qtd > 8) return 44;
      return 52;
    },

    fonteSlideApresentacao(qtd) {
      if (qtd > 18) return 'text-body-2';
      if (qtd > 8) return 'text-body-1';
      return 'text-h6';
    },

    fecharApresentacaoSorteio() {
      this.dialogResultadoSorteio = false;
    },

    proximoSlideSorteio() {
      const total = this.resultadoSorteioGruposApresentacao.length;
      this.resultadoSorteioSlide = (this.resultadoSorteioSlide + 1) % total;
    },

    slideAnteriorSorteio() {
      const total = this.resultadoSorteioGruposApresentacao.length;
      this.resultadoSorteioSlide = (this.resultadoSorteioSlide - 1 + total) % total;
    },

    handleKeydownApresentacaoSorteio(e) {
      if (e.key === 'ArrowRight') this.proximoSlideSorteio();
      if (e.key === 'ArrowLeft') this.slideAnteriorSorteio();
    },

    // --- copiar/baixar imagem de uma tabela (Resultado Sorteio, e Classificação/Filial por mês e acumulado) ---

    suportaCopiarImagem() {
      return !!(navigator.clipboard && window.ClipboardItem);
    },

    refImagemMes(mes) {
      return this.visaoTabelaCampanha === 'classificacao' ? `tabelaMesClassificacao_${mes.mes}` : `tabelaMesFilial_${mes.mes}`;
    },

    refImagemAcumulado() {
      return this.visaoTabelaCampanha === 'classificacao' ? 'tabelaAcumuladoClassificacao' : 'tabelaAcumuladoFilial';
    },

    // true enquanto a tabela `refName` (copiar OU baixar) está sendo processada — usado pra mostrar o
    // overlay de carregamento só em cima da tabela certa, não no dialog inteiro
    processandoImagem(refName) {
      return !!this.imagemProcessando && this.imagemProcessando.startsWith(`${refName}:`);
    },

    capturarImagemTabela(refName) {
      const el = this.$refs[refName];
      const elemento = Array.isArray(el) ? el[0] : el;
      if (!elemento) return Promise.reject(new Error('Elemento não encontrado'));

      // tabela alta (muita gente/muitas filiais visíveis) usa escala menor — a nitidez extra do scale:2 não
      // compensa o tempo de renderização, e é justamente nessas tabelas grandes que a travada mais incomoda
      const scale = elemento.scrollHeight > 1200 ? 1 : 2;

      return html2canvas(elemento, {
        backgroundColor: '#FFFFFF',
        scale,
        // (foreignObjectRendering foi testado e removido: deixava a imagem toda preta em algumas
        // combinações de CSS — bug conhecido do html2canvas. Fica só a escala adaptativa + ignoreElements
        // pra reduzir a travada, mesmo sem esse ganho extra de velocidade)
        // os grupos de vendedor recolhidos (v-show, não v-if) continuam inteiros no DOM, só escondidos —
        // sem isso o html2canvas processa até vendedor de filial/classificação recolhida, o que trava a
        // página por um bom tempo em listas grandes
        ignoreElements: (node) => node.style && node.style.display === 'none',
      });
    },

    async baixarImagemTabela(refName, nomeArquivo) {
      if (this.imagemProcessando) return;
      this.imagemProcessando = `${refName}:baixar`;
      // espera o próximo frame antes do html2canvas (síncrono/pesado) travar a thread, pra garantir que o
      // spinner do botão já pintou na tela
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
        const canvas = await this.capturarImagemTabela(refName);
        await new Promise((resolve) => {
          canvas.toBlob((blob) => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeArquivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            this.snackbarImagem = { show: true, text: 'Imagem baixada!', color: 'success' };
            resolve();
          });
        });
      } catch (e) {
        this.snackbarImagem = { show: true, text: 'Erro ao gerar a imagem.', color: 'error' };
      } finally {
        this.imagemProcessando = null;
      }
    },

    async copiarImagemTabela(refName) {
      if (this.imagemProcessando) return;
      this.imagemProcessando = `${refName}:copiar`;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
        const canvas = await this.capturarImagemTabela(refName);
        await new Promise((resolve) => {
          canvas.toBlob(async (blob) => {
            try {
              await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
              this.snackbarImagem = { show: true, text: 'Imagem copiada!', color: 'success' };
            } catch (e) {
              this.snackbarImagem = { show: true, text: 'Não foi possível copiar a imagem.', color: 'error' };
            }
            resolve();
          });
        });
      } catch (e) {
        this.snackbarImagem = { show: true, text: 'Erro ao gerar a imagem.', color: 'error' };
      } finally {
        this.imagemProcessando = null;
      }
    },

    // Bloco F (meta trimestral) só existe nos meses que fecham um trimestre da campanha — mesRef vem como
    // "aaaa-mm" (mes.mes, ex: "2026-09")
    mesFechaTrimestre(mesRef) {
      const mm = (mesRef || '').slice(5, 7);
      return mm === '09' || mm === '12';
    },

    toggleGrupo(chave) {
      const s = new Set(this.gruposExpandidos);
      if (s.has(chave)) s.delete(chave); else s.add(chave);
      this.gruposExpandidos = s;
    },

    abrirDialogCampanhaVendaMargem() {
      this.dialogCampanhaVendaMargem = true;
    },

    campanhaVendaMargemBlocoInfo(chave) {
      const infos = {
        regra1: {
          titulo: 'Regra 1 — Classificação mensal', campo: 'cupons_regra1',
          campoVenda: 'venda', labelVenda: 'Venda', mostrarAtingimento: true, mostrarMargem: true,
        },
        a: {
          titulo: 'Bloco A — Quem mais vendeu na rede', campo: 'cupons_bloco_a',
          campoVenda: 'venda', labelVenda: 'Venda', mostrarAtingimento: true, mostrarMargem: true,
        },
        b: {
          titulo: 'Bloco B — Quem mais vendeu na filial', campo: 'cupons_bloco_b',
          campoVenda: 'venda', labelVenda: 'Venda', mostrarAtingimento: true, mostrarMargem: true,
        },
        c: {
          // rankeado por pontuação (Educa Comercial Ivaiporã), não por venda — venda é só informativa
          titulo: 'Bloco C — Top 10 e-book', campo: 'cupons_bloco_c',
          campoVenda: 'venda_bloco_c', labelVenda: 'Valor e-book',
          campoExtra: 'pontos_bloco_c', labelExtra: 'Pontos', campoOrdenacao: 'pontos_bloco_c',
          mostrarAtingimento: false, mostrarMargem: false,
        },
        d: {
          titulo: 'Bloco D — Produto sem giro', campo: 'cupons_bloco_d',
          campoVenda: 'venda_bloco_d', labelVenda: 'Venda (produto sem giro)', campoMargem: 'margem_bloco_d',
          mostrarAtingimento: false, mostrarMargem: true,
        },
        e: {
          titulo: 'Bloco E — Individual (margem + meta)', campo: 'cupons_bloco_e',
          campoVenda: 'venda', labelVenda: 'Venda', mostrarAtingimento: true, mostrarMargem: true,
        },
        f: {
          // só existe nos meses que fecham trimestre (set/dez) — venda/margem são do trimestre inteiro, não
          // só do mês, por isso usa campos próprios em vez dos genéricos "venda"/"margem"
          titulo: 'Bloco F (Meta trimestral)', campo: 'cupons_bloco_f',
          campoVenda: 'venda_bloco_f', labelVenda: 'Venda do trimestre', campoMargem: 'margem_bloco_f',
          campoExtra: 'meta_bloco_f', labelExtra: 'Meta do trimestre', extraFormatoMoeda: true,
          mostrarAtingimento: false, mostrarMargem: true,
        },
        total: {
          titulo: 'Total Geral', campo: 'total_cupons',
          campoVenda: 'venda', labelVenda: 'Venda', mostrarAtingimento: true, mostrarMargem: true,
        },
      };
      return infos[chave] || null;
    },

    abrirDetalheBlocoCampanha(mes, chave) {
      this.campanhaVendaMargemDetalheMes = mes;
      this.campanhaVendaMargemDetalheChave = chave;
      this.dialogCampanhaVendaMargemDetalhe = true;
    },

    listaCampanhaVendaMargemPorMes() {
      this.carregandoVendaMargem = true;
      return axios
          .post(`${this.backendUrl}bonificacao/campanha-venda-margem/meses/listar`, {})
          .then((res) => {
            this.campanhaVendaMargemMeses = res.data || [];
            this.carregandoVendaMargem = false;
          })
          .catch(() => {
            this.campanhaVendaMargemMeses = [];
            this.carregandoVendaMargem = false;
          });
    },

    aplicarPeriodoAcumulado(inicio, fim) {
      this.filtroAcumuladoInicio = inicio;
      this.filtroAcumuladoFim = fim;
      this.listaCampanhaVendaMargemAcumuladoFiltrado();
    },

    listaCampanhaVendaMargemAcumuladoFiltrado() {
      this.carregandoAcumuladoFiltrado = true;
      return axios
          .post(`${this.backendUrl}bonificacao/campanha-venda-margem/acumulado/listar`, {
            mesinicio: this.filtroAcumuladoInicio,
            mesfim: this.filtroAcumuladoFim,
          })
          .then((res) => {
            this.campanhaVendaMargemAcumuladoFiltrado = res.data || [];
            this.carregandoAcumuladoFiltrado = false;
          })
          .catch(() => {
            this.campanhaVendaMargemAcumuladoFiltrado = [];
            this.carregandoAcumuladoFiltrado = false;
          });
    },

    listaCampanhaVendaMargemAcumulado() {
      this.carregandoVendaMargemAcumulado = true;
      return axios
          .post(`${this.backendUrl}bonificacao/campanha-venda-margem/acumulado/listar`, {})
          .then((res) => {
            this.campanhaVendaMargemAcumulado = res.data || [];
            this.carregandoVendaMargemAcumulado = false;
          })
          .catch(() => {
            this.campanhaVendaMargemAcumulado = [];
            this.carregandoVendaMargemAcumulado = false;
          });
    },
    // ------------------
  },
  watch: {
    // modo apresentação do Resultado Sorteio — entra/sai da tela cheia de verdade (F11) e liga/desliga a
    // navegação por teclado junto com a abertura/fechamento do dialog (cobre tanto o botão de fechar quanto
    // o ESC nativo do v-dialog)
    dialogResultadoSorteio(aberto) {
      if (aberto) {
        const elem = document.documentElement;
        if (elem.requestFullscreen) elem.requestFullscreen();
        else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
        else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
        else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
        window.addEventListener('keydown', this.handleKeydownApresentacaoSorteio);
      } else {
        window.removeEventListener('keydown', this.handleKeydownApresentacaoSorteio);
        if (document.fullscreenElement) {
          if (document.exitFullscreen) document.exitFullscreen().catch(() => {});
          else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
          else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
          else if (document.msExitFullscreen) document.msExitFullscreen();
        }
      }
    },
  },
  created() {
    if (this.permissao('dashboard_ranking_campanha_venda_margem_diretoria')) {
      this.listaCampanhaVendaMargemPorMes();
      this.listaCampanhaVendaMargemAcumulado();
      this.listaCampanhaVendaMargemAcumuladoFiltrado();
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydownApresentacaoSorteio);
  },
};
</script>

<style scoped>

/* a regra genérica ".v-dialog { max-height: 97% }" (em DashboardRankingVendas.vue) é pensada pros dialogs
   "normais" (não encostarem na borda da tela) — o dialog do modo apresentação do Resultado Sorteio usa
   fullscreen de verdade e precisa ocupar 100%, senão sobra uma fresta embaixo mostrando o fundo da página.
   ::v-deep necessário porque o wrapper ".v-dialog" que o Vuetify gera fica alguns níveis abaixo da raiz que
   o <v-dialog> renderiza, não recebe o atributo de escopo automaticamente. */
::v-deep .v-dialog.v-dialog--fullscreen {
  max-height: 100% !important;
}

/* scroll discreto do card de cada slide do modo apresentação (Resultado Sorteio), quando a classificação
   tem gente demais pra caber inteira na tela mesmo com a linha compacta */
.apresentacao-sorteio-scroll {
  scrollbar-width: thin;
  scrollbar-color: #0B5C73 #E0E0E0;
}
.apresentacao-sorteio-scroll::-webkit-scrollbar {
  width: 8px;
}
.apresentacao-sorteio-scroll::-webkit-scrollbar-track {
  background: #E0E0E0;
  border-radius: 4px;
}
.apresentacao-sorteio-scroll::-webkit-scrollbar-thumb {
  background: #0B5C73;
  border-radius: 4px;
}

/* botões de copiar/baixar sobrepostos na barra de classificação (Resultado Sorteio) — fundo translúcido
   branco pra destacar em cima de qualquer cor de classificação, sem depender de qual cor é */
.resultado-sorteio-acao-btn {
  background: rgba(255, 255, 255, 0.22) !important;
}
.resultado-sorteio-acao-btn:hover {
  background: rgba(255, 255, 255, 0.36) !important;
}

/* resumo por classificação na visão por filial — chip redondo tipo medalha, só com o número */
.classificacao-medalha.v-chip {
  border-radius: 50% !important;
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0 !important;
  justify-content: center;
}
::v-deep .classificacao-medalha .v-chip__content {
  padding: 0;
  justify-content: center;
}

/* grupo de ações (copiar/baixar imagem) das tabelas de Classificação/Filial — mesmo visual do .visao-toggle
   ao lado: fundo cinza claro, botões "depressed" (sem sombra própria) encostados um no outro, e o
   border-radius fica só no container (com overflow hidden cortando os cantos dos botões das pontas), em vez
   de cada botão ter seu próprio arredondado — é exatamente como o Vuetify monta o segmented control do
   .visao-toggle. Altura travada em 30px igual à do .visao-toggle (mesmo valor nas duas regras) pra não
   depender do cálculo de altura padrão do Vuetify pra cada combinação de props, que difere entre os dois */
.campanha-acao-imagem-group {
  background: #EEEEEE;
  border-radius: 18px;
  height: 30px;
  overflow: hidden;
}
.campanha-acao-imagem-divisor {
  width: 1px;
  height: 16px;
  background: rgba(0, 0, 0, 0.15);
}
.campanha-acao-imagem-btn.v-btn {
  height: 30px !important;
  min-width: 32px !important;
  padding: 0 8px !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  color: #546E7A;
}
.campanha-acao-imagem-btn.v-btn:hover {
  color: #0B5C73;
  background: rgba(11, 92, 115, 0.1) !important;
}

/* seletor de visão (Classificação/Filial/...) das abas da campanha — visual de segmented control em vez do
   grupo de botões quadrados padrão do Vuetify */
.visao-toggle.v-btn-toggle {
  background: #EEEEEE !important;
  box-shadow: none !important;
  height: 30px !important;
}
.visao-toggle.v-btn-toggle .v-btn {
  height: 30px !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: normal;
  opacity: 1;
}
.visao-toggle.v-btn-toggle .v-btn.v-btn--active {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

/* barra de período da aba Acumulado — mesmo visual do cabeçalho do painel de totalizadores (fundo claro + faixa
   lateral), campos "solo-inverted" cinza e compactos em vez de caixas com borda */
.periodo-filtro {
  background: #F7F9FA;
  border-left: 4px solid #0B5C73;
  gap: 2px;
}
.totalizadores-header {
  cursor: pointer;
  user-select: none;
}
.totalizadores-titulo {
  min-height: 36px;
}
/* enquanto o período novo carrega, os cards não podem mostrar os valores do período anterior como se estivessem
   atualizados: desfoca os números, pulsa e bloqueia o clique */
.totalizadores-cards {
  transition: opacity 0.2s ease, filter 0.2s ease;
}
.totalizadores-cards--carregando {
  opacity: 0.55;
  filter: blur(3px);
  pointer-events: none;
  animation: totalizadores-pulso 1.2s ease-in-out infinite;
}
@keyframes totalizadores-pulso {
  0%, 100% { opacity: 0.55; }
  50% { opacity: 0.3; }
}
.periodo-filtro-grupo {
  cursor: default;
}
.periodo-filtro-campo {
  width: 250px;
  max-width: 100%;
  flex: 0 0 auto;
}

/* o padding horizontal do conteúdo do expansion-panel vive num div interno gerado pelo Vuetify
   (.v-expansion-panel-content__wrap), que a prop "class" do componente não alcança — por isso o
   px-0 sozinho não alinha os cards com a tabela abaixo */
::v-deep .campanha-totais-expansion .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 6px;
}
</style>
